<template>
  <main :class="{ 'section-loading': filterLoading, 'boxPadding': isBox }">
    <div class="tab-header">
      <div class="container-fluid">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" :class="{ 'active': currentTab === 0 }" @click="setRouteQuery('0')">
            <a href="#tab-0" class="nav-link active show" role="tab" data-toggle="tab">條件篩選</a>
          </li>
          <li class="nav-item" :class="{ 'active': currentTab === 1 }" @click="setRouteQuery('1')">
            <a href="#tab-1" class="nav-link" role="tab" data-toggle="tab">查詢記錄</a>
          </li>
          <li class="nav-item" :class="{ 'active': currentTab === 2 }" @click="setRouteQuery('2')">
            <a href="#tab-2" class="nav-link" role="tab" data-toggle="tab">我的最愛</a>
          </li>
          <!-- <li class="nav-item" :class="{'active': currentTab===3}" @click="setRouteQuery('3')">
            <a href="#tab-3" class="nav-link" role="tab" data-toggle="tab">主管推薦</a>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="tab-content">
      <div class="container-fluid">
        <div id="tab-0" class="tab-pane active show" role="tabpanel">
          <form class="form">
            <div class="row mb-3">
              <div class="col-9">
                <h3
                  v-show="customizeData.age.length > 0 || customizeData.info.length > 0 || customizeData.financial.length > 0 || customizeData.service.length > 0"
                  class="m-0 mt-1 mb-2">個人資訊<span class="pl-5 text-red">※點擊右方「編輯篩選項目」可重新設定條件</span></h3>
              </div>
              <div class="col-3 text-right">
                <a class="btn btn-default m-0" @click="panelOpen('customizeModalOpen')">編輯篩選項目</a>
              </div>
            </div>
            <div v-show="customizeData.age.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green m-0">年紀相關</h4>
              <div v-show="customizeData.age.indexOf('idage') !== -1" class="form-group row">
                <label class="col-2 text-right">年齡</label>
                <div class="col-10">
                  <div class="row">
                    <div v-for="(idage, index) in formSelect.idage" :key="index"
                      :class="[idage.ser_no === 3 ? colsi : coltr]">
                      <div v-if="!(idage.ser_no === 3)" class="radio">
                        <input type="radio" name="radio-idage" v-model="formSelectItem.idage"
                          :id="`age-${idage.ser_no}`" :value="idage.option"
                          @click="toggleRadio(`age-${idage.ser_no}`, 'idage', idage.option)">
                        <label :for="`age-${idage.ser_no}`">{{ idage.name }}</label>
                      </div>
                      <div v-else class="radio">
                        <input type="radio" name="radio-idage" v-model="formSelectItem.idage"
                          :id="`age-${idage.ser_no}`" :value="`min:${form.extraAge[0]}/max:${form.extraAge[1]}`"
                          @click="toggleRadio(`age-${idage.ser_no}`, 'idage', `min:${form.extraAge[0]}/max:${form.extraAge[1]}`)">
                        <label :for="`age-${idage.ser_no}`">
                          <input type="text" class="form-control form-control-inline form-short"
                            v-model="form.extraAge[0]" maxlength="3" @input="checkExtraAge(0)" />
                          <span class="text">~</span>
                          <input type="text" class="form-control form-control-inline form-short"
                            v-model="form.extraAge[1]" maxlength="3" @input="checkExtraAge(1)" />
                          <span class="text">歲(含)</span>
                        </label>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div v-show="customizeData.age.indexOf('birthmonth') !== -1" class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="birthMonth" class="col-4 text-right">生日月份</label>
                    <div class="col-5">
                      <select v-model="formSelectItem.birthmonth" id="birthMonth" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(birthmonth, index) in formSelect.birthmonth" :key="index"
                          :value="birthmonth.option">{{ birthmonth.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.age.indexOf('agemonth') !== -1" class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="add-age" class="col-4 text-right">增齡月份</label>
                    <div class="col-5">
                      <select v-model="formSelectItem.agemonth" id="add-age" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(agemonth, index) in formSelect.agemonth" :key="index" :value="agemonth.option">
                          {{ agemonth.name }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.age.indexOf('recent_birthday') !== -1" class="row">
                <div class="col-6">
                  <div class="form-group row">
                    <label for="recent-birthday" class="col-4 text-right">近期生日</label>
                    <div class="col-3">
                      <select v-model="formSelectItem.recent_birthday" id="recent-birthday" class="form-control">
                        <option value="">請選擇</option>
                        <option v-for="(item, index) in formSelect.recent_birthday" :key="index" :value="item.option">
                          {{ item.name }}</option>
                      </select>
                    </div>
                    <label class="text-right">日內生日</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="customizeData.info.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green m-0">基本資料</h4>
              <div v-show="customizeData.info.indexOf('sex') !== -1" class="form-group row">
                <label for="gender-1" class="col-2 text-right">性別</label>
                <div class="col-10">
                  <div v-for="(sex, index) in formSelect.sex" :key="index" class="radio radio-inline mr-5">
                    <input type="radio" name="radio-sex" v-model="formSelectItem.sex" :id="`gender-${sex.ser_no}`"
                      :value="sex.option" @click="toggleRadio(`gender-${sex.ser_no}`, 'sex', sex.option)">
                    <label :for="`gender-${sex.ser_no}`">{{ sex.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.info.indexOf('home_addr') !== -1" class="form-group row">
                <label for="group" class="col-2 text-right">現居地址</label>
                <div class="col-10">
                  <select v-model="formSelectItem.home_addr.city" @change="changeCity" id="group"
                    class="form-control form-control-inline form-wide">
                    <option value="">請選擇縣市</option>
                    <option v-for="(city, cid) in cityOpt" :key="`city-item-${cid}`" :value="city">{{ city }}</option>
                  </select>
                  <select v-model="formSelectItem.home_addr.zip" id="group"
                    class="form-control form-control-inline form-wide" :disabled="formSelectItem.home_addr.city === ''">
                    <option value="">請選擇鄉鎮市區</option>
                    <option v-for="(area, aid) in areaOpt" :key="`area-item-${aid}`" :value="area.area">{{ area.area }}
                    </option>
                  </select>
                  <input v-if="customizeData.info.indexOf('home_addr') !== -1" type="text"
                    class="form-control form-control-inline form-wide" :disabled="formSelectItem.home_addr.zip === ''"
                    v-model="formSelectItem.home_addr.street" alt="ch" maxlength="100" @input="checkInputAddress"
                    @blur="checkInputAddress" />
                </div>
              </div>
              <div v-show="customizeData.info.indexOf('groups') !== -1" class="form-group row">
                <label class="col-2 text-right">所屬群組</label>
                <div class="col-10">
                  <div class="form-control h-auto" @click="openGroupModal(formSelectItem.groups, grpOpt)">
                    <div v-if='formSelectItem.groups.length == 0' style="padding:8px 0px;">
                      請選擇或輸入群組名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.groups" :key="`selectedGroup-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.info.indexOf('marry') !== -1" class="form-group row">
                <label for="marriage" class="col-2 text-right">婚姻狀況</label>
                <div class="col-10" id="marriage">
                  <select v-model="formSelectItem.marry" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(marry, index) in formSelect.marry" :key="index" :value="marry.option">{{ marry.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.info.indexOf('edu') !== -1" class="form-group row">
                <label for="education" class="col-2 text-right">教育程度</label>
                <div class="col-10" id="education">
                  <select v-model="formSelectItem.edu" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(edu, index) in formSelect.edu" :key="index" :value="edu.option">{{ edu.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.info.indexOf('std_occupation_cd') !== -1" class="form-group row">
                <label for="career" class="col-2 text-right">職業</label>
                <div class="col-10" id="career">
                  <b v-if="formSelectItem.std_occupation_cd" class="text px-3 text-green">第{{
                    formSelectItem.jobCategory
                  }}類 {{ formSelectItem.job_name }}</b>
                  <a class="btn btn-default m-0" @click="jobPickingOpen = true">請選擇</a>
                </div>
              </div>
            </div>
            <div v-show="customizeData.financial.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green m-0">財務狀況</h4>
              <div v-show="customizeData.financial.indexOf('incomy') !== -1" class="form-group row">
                <label class="col-2 text-right">個人年所得</label>
                <div class="col-10">
                  <select v-model="formSelectItem.incomy" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(incomy, index) in formSelect.incomy" :key="index" :value="incomy.option">
                      {{ incomy.name }}</option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.financial.indexOf('family_incom') !== -1" class="form-group row">
                <label class="col-2 text-right">家庭年所得</label>
                <div class="col-10">
                  <select v-model="formSelectItem.family_incom" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(family_incom, index) in formSelect.family_incom" :key="index"
                      :value="family_incom.option">{{ family_incom.name }}</option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.financial.indexOf('invest') !== -1" class="form-group row">
                <label class="col-2 text-right">月平均投資</label>
                <div class="col-10">
                  <select v-model="formSelectItem.invest" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(invest, index) in formSelect.invest" :key="index" :value="invest.option">
                      {{ invest.name }}</option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.financial.indexOf('finance') !== -1" class="form-group row">
                <label class="col-2 text-right">理財工具</label>
                <div class="col-10">
                  <div v-for="(finance, index) in formSelect.finance" :key="index" class="checkbox checkbox-inline">
                    <input type="checkbox" :id="`financial_tools-${finance.ser_no}`" v-model="formSelectItem.finance"
                      v-if="finance.name == '無理財工具'" :value="finance.option">
                    <input v-else type="checkbox" :id="`financial_tools-${finance.ser_no}`"
                      v-model="formSelectItem.finance" :disabled="formSelectItem.finance.includes('4')"
                      :value="finance.option">
                    <label :for="`financial_tools-${finance.ser_no}`">{{ finance.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.financial.indexOf('house') !== -1" class="form-group row">
                <label class="col-2 text-right">住宅權屬</label>
                <div class="col-10">
                  <select v-model="formSelectItem.house" class="form-control form-control-inline form-wide">
                    <option value="">請選擇</option>
                    <option v-for="(house, index) in formSelect.house" :key="index" :value="house.option">{{ house.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.financial.indexOf('car') !== -1" class="form-group row">
                <label class="col-2 text-right">交通工具</label>
                <div class="col-10">
                  <div v-for="(car, index) in formSelect.car" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-car" :id="`transport-${car.ser_no}`" v-model="formSelectItem.car"
                      :value="car.option" @click="toggleRadio(`transport-${car.ser_no}`, 'car', car.option)">
                    <label :for="`transport-${car.ser_no}`">{{ car.name }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="customizeData.service.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">申辦項目</h4>
              <div v-show="customizeData.service.indexOf('web_member') !== -1" class="form-group row mt-2">
                <label for="service_company-1" class="col-2 text-right">公司網站會員</label>
                <div class="col-10">
                  <div v-for="(web_member, index) in formSelect.web_member" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-web_member" :id="`service_company-${web_member.ser_no}`"
                      v-model="formSelectItem.web_member" :value="web_member.option"
                      @click="toggleRadio(`service_company-${web_member.ser_no}`, 'web_member', web_member.option)">
                    <label :for="`service_company-${web_member.ser_no}`">{{ web_member.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('online') !== -1" class="form-group row mt-2">
                <label for="service_updateonline-1" class="col-2 text-right">網路服務線上變更</label>
                <div class="col-10">
                  <div v-for="(online, index) in formSelect.online" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-online" :id="`service_updateonline-${online.ser_no}`"
                      v-model="formSelectItem.online" :value="online.option"
                      @click="toggleRadio(`service_updateonline-${online.ser_no}`, 'online', online.option)">
                    <label :for="`service_updateonline-${online.ser_no}`">{{ online.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('mobile') !== -1" class="form-group row mt-2">
                <label for="service_mobile-1" class="col-2 text-right">行動服務</label>
                <div class="col-10">
                  <div v-for="(mobile, index) in formSelect.mobile" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-mobile" :id="`service_mobile-${mobile.ser_no}`"
                      v-model="formSelectItem.mobile" :value="mobile.option"
                      @click="toggleRadio(`service_mobile-${mobile.ser_no}`, 'mobile', mobile.option)">
                    <label :for="`service_mobile-${mobile.ser_no}`">{{ mobile.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('payment') !== -1" class="form-group row mt-2">
                <label for="service_onefinger-1" class="col-2 text-right">ID一指通</label>
                <div class="col-10">
                  <div v-for="(payment, index) in formSelect.payment" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-payment" :id="`service_onefinger-${payment.ser_no}`"
                      v-model="formSelectItem.payment" :value="payment.option"
                      @click="toggleRadio(`service_onefinger-${payment.ser_no}`, 'payment', payment.option)">
                    <label :for="`service_onefinger-${payment.ser_no}`">{{ payment.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('email') !== -1" class="form-group row mt-2">
                <label for="service_ebill-1" class="col-2 text-right">電子單據</label>
                <div class="col-10">
                  <div v-for="(email, index) in formSelect.email" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-email" :id="`service_ebill-${email.ser_no}`"
                      v-model="formSelectItem.email" :value="email.option"
                      @click="toggleRadio(`service_ebill-${email.ser_no}`, 'email', email.option)">
                    <label :for="`service_ebill-${email.ser_no}`">{{ email.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('trans_plpy') !== -1" class="form-group row mt-2">
                <label for="service_transfer-1" class="col-2 text-right">轉帳申請</label>
                <div class="col-10">
                  <div v-for="(trans_plpy, index) in formSelect.trans_plpy" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-trans_plpy" :id="`service_transfer-${trans_plpy.ser_no}`"
                      v-model="formSelectItem.trans_plpy" :value="trans_plpy.option"
                      @click="toggleRadio(`service_transfer-${trans_plpy.ser_no}`, 'trans_plpy', trans_plpy.option)">
                    <label :for="`service_transfer-${trans_plpy.ser_no}`">{{ trans_plpy.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.service.indexOf('ecall') !== -1" class="form-group row mt-2">
                <label for="service_eazycall-1" class="col-2 text-right">易Call保</label>
                <div class="col-10">
                  <div v-for="(ecall, index) in formSelect.ecall" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-ecall" :id="`service_eazycall-${ecall.ser_no}`"
                      v-model="formSelectItem.ecall" :value="ecall.option"
                      @click="toggleRadio(`service_eazycall-${ecall.ser_no}`, 'ecall', ecall.option)">
                    <label :for="`service_eazycall-${ecall.ser_no}`">{{ ecall.name }}</label>
                  </div>
                </div>
              </div>
              <!-- 2022/11/08 【裁罰配套】主管推薦管控措施 -->
              <!-- <div v-show="customizeData.service.indexOf('policy_loan') !== -1" class="form-group row mt-2">
                <label for="service_insureloan-1" class="col-2 text-right">保單貸款</label>
                <div class="col-10">
                  <div v-for="(policy_loan, index) in formSelect.policy_loan" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-policy_loan" :id="`service_insureloan-${policy_loan.ser_no}`" v-model="formSelectItem.policy_loan" :value="policy_loan.option" @click="toggleRadio(`service_insureloan-${policy_loan.ser_no}`, 'policy_loan', policy_loan.option)">
                    <label :for="`service_insureloan-${policy_loan.ser_no}`">{{policy_loan.name}}</label>
                  </div>
                </div>
              </div> -->
              <div v-show="customizeData.service.indexOf('claimoffset') !== -1" class="form-group row mt-2">
                <label for="service_settlement-1" class="col-2 text-right">理賠抵繳</label>
                <div class="col-10">
                  <div v-for="(claimoffset, index) in formSelect.claimoffset" :key="index" class="radio radio-inline">
                    <input type="radio" name="radio-claimoffset" :id="`service_settlement-${claimoffset.ser_no}`"
                      v-model="formSelectItem.claimoffset" :value="claimoffset.option"
                      @click="toggleRadio(`service_settlement-${claimoffset.ser_no}`, 'claimoffset', claimoffset.option)">
                    <label :for="`service_settlement-${claimoffset.ser_no}`">{{ claimoffset.name }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="customizeData.customerType.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">客戶類型</h4>
              <div v-show="customizeData.customerType.indexOf('custrl') !== -1" class="form-group row">
                <label class="col-2 text-right">客戶關係</label>
                <div class="col-10">
                  <div v-for="(custrl, index) in formSelect.custrl" :key="index" class="radio radio-inline mr-5">
                    <input type="radio" name="radio-custrl" :id="`customer-relation-${custrl.ser_no}`"
                      :value="custrl.option" v-model="formSelectItem.custrl"
                      @click="toggleRadio(`customer-relation-${custrl.ser_no}`, 'custrl', custrl.option)" />
                    <label :for="`customer-relation-${custrl.ser_no}`">{{ custrl.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.customerType.indexOf('custrl1') !== -1" class="form-group row">
                <label class="col-2 text-right">保單關係人</label>
                <div class="col-10">
                  <div v-for="(custrl1, index) in formSelect.custrl1" :key="index" class="radio radio-inline mr-5">
                    <input type="radio" name="radio-custrl1" :id="`customer-type-${custrl1.ser_no}`"
                      :value="custrl1.option" v-model="formSelectItem.custrl1"
                      @click="toggleRadio(`customer-type-${custrl1.ser_no}`, 'custrl1', custrl1.option)" />
                    <label :for="`customer-type-${custrl1.ser_no}`">{{ custrl1.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.customerType.indexOf('custrl2') !== -1" class="form-group row">
                <label class="col-2 text-right">幾年未再購</label>
                <div class="col-2">
                  <select v-model="formSelectItem.custrl2" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(year_select, index) in formSelect.year_select" :key="index"
                      :value="year_select.option">{{ year_select.name }}</option>
                  </select>
                </div>
                <div style="line-height:40px">(以有效契約要保人搜尋)</div>
              </div>
              <div v-show="customizeData.customerType.indexOf('custrl3') !== -1" class="form-group row">
                <label class="col-2 text-right">近期有購買</label>
                <div class="col-2">
                  <select v-model="formSelectItem.custrl3" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(year_select, index) in formSelect.year_select" :key="index"
                      :value="year_select.option">{{ year_select.name }}</option>
                  </select>
                </div>
                <div style="line-height:40px">(以有效契約要保人搜尋)</div>
              </div>
              <div v-show="customizeData.customerType.indexOf('custrl4') !== -1" class="form-group row">
                <label class="col-2 text-right">投保始期</label>
                <span class="text ml-2 mr-1">民國</span>
                <input type="text mr-1" class="form-control form-control-inline" style="width: 90px;"
                  v-model="formSelectItem.inputYear" maxlength="3" @input="checkYear" />
                <span class="text ml-1 mr-3">年</span>
                <select v-model="formSelectItem.custrl4" class="form-control form-control-inline mr-2">
                  <option value="">請選擇</option>
                  <option v-for="(month_select, index) in formSelect.month_select" :key="index"
                    :value="month_select.option">{{ month_select.name }}</option>
                </select>
                <span class="text">月</span>
              </div>
              <div v-show="customizeData.customerType.indexOf('vip_lvl') !== -1" class="form-group row">
                <label class="col-2 text-right">VIP客戶</label>
                <div class="col-10">
                  <div v-for="(vip_lvl, index) in formSelect.vip_lvl" :key="index" class="checkbox checkbox-inline">
                    <input type="checkbox" :id="`customerType-${vip_lvl.ser_no}`" :value="vip_lvl.option"
                      v-model="formSelectItem.vip_lvl" />
                    <label :for="`customerType-${vip_lvl.ser_no}`">{{ vip_lvl.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.customerType.indexOf('cust_tag') !== -1" class="form-group row">
                <label class="col-2 text-right">客戶標籤</label>
                <div class="col-8">
                  <div class="form-control h-auto" @click="openCustTagModal(formSelectItem.cust_tag)">
                    <div v-if='formSelectItem.cust_tag.length == 0' style="padding:8px 0px;">
                      請選擇客戶標籤
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.cust_tag" :key="`selectedCustTag-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
                <label class="col-2 text-green underline" @click="openTagInfoModal">說明</label>
              </div>
              <div v-show="customizeData.customerType.indexOf('cont_score') !== -1" class="form-group row">
                <label class="col-2 text-right">親疏等級</label>
                <div class="col-10">
                  <div v-for="(contScore, index) in formSelect.cont_score" :key="index" class="radio radio-inline mr-5">
                    <input type="radio" name="radio-cont_score" :id="`cont-score-${contScore.ser_no}`"
                      :value="contScore.option" v-model="formSelectItem.cont_score"
                      @click="toggleRadio(`cont-score-${contScore.ser_no}`, 'cont_score', contScore.option)" />
                    <label :for="`cont-score-${contScore.ser_no}`">{{ contScore.name }}</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.customerType.indexOf('match_cnt') !== -1" class="form-group row">
                <label class="col-2 text-right">符合名單專區次數</label>
                <div class="col-2">
                  <select v-model="formSelectItem.match_cnt" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(cnt_select, index) in formSelect.cnt_select" :key="index"
                      :value="cnt_select.option">{{ cnt_select.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div v-show="customizeData.isInsure.length > 0 || customizeData.notInsure.length > 0 || customizeData.cathayCustInfo.length > 0" class="row">
              <div class="col-12">
                <h3>商品行銷</h3>
              </div>
            </div>
            <div class="panel panel-default mb-2" v-show="customizeData.isInsure.length > 0">
              <h4 class="text-green mt-0">已投保商品</h4>
              <div v-show="customizeData.isInsure.indexOf('prod_codes_curr') !== -1" class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約幣別</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id='prod_codes-1' value="NTD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-1">台幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id='prod_codes-2' value="USD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-2">美元</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id='prod_codes-3' value="AUD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-3">澳幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id='prod_codes-4' value="NZD" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-4">紐幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id='prod_codes-5' value="CNY" v-model="formSelectItem.prod_codes_curr">
                    <label for="prod_codes-5">人民幣</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.isInsure.indexOf('prod_codes_main') !== -1" class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto"
                    @click="openSelectModal(formSelectItem.prod_codes.main, mainPlanOpt, 'prod_codes', 'main')">
                    <div v-if='formSelectItem.prod_codes.main.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.prod_codes.main" :key="`selectedMainContract2-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.isInsure.indexOf('prod_codes_atta') !== -1" class="form-group row">
                <label for="not_insure_subDoc" class="col-2 text-right">附約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto"
                    @click="openSelectModal(formSelectItem.prod_codes.atta, secondaryPlanOpt, 'prod_codes', 'atta')">
                    <div v-if='formSelectItem.prod_codes.atta.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.prod_codes.atta" :key="`selectedAttaContract2-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.isInsure.indexOf('prod_type') !== -1" class="form-group row">
                <label for="insure_prod_type" class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" @click="openProdTypeModal(formSelectItem.prod_type, '1')">
                    <div v-if='formSelectItem.prod_type.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.prod_type" :key="`selected-prod-type-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="customizeData.notInsure.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">未投保商品</h4>
              <div v-show="customizeData.notInsure.indexOf('prod_codes_n_curr') !== -1" class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約幣別</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="prod_codes_n-1" value="NTD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-1">台幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="prod_codes_n-2" value="USD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-2">美元</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="prod_codes_n-3" value="AUD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-3">澳幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="prod_codes_n-4" value="NZD" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-4">紐幣</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="prod_codes_n-5" value="CNY" v-model="formSelectItem.prod_codes_n_curr">
                    <label for="prod_codes_n-5">人民幣</label>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.notInsure.indexOf('prod_codes_n_main') !== -1" class="form-group row mt-2">
                <label for="not_insure_mainDoc" class="col-2 text-right">主約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto"
                    @click="openSelectModal(formSelectItem.prod_codes_n.main, mainPlanOpt, 'prod_codes_n', 'main')">
                    <div v-if='formSelectItem.prod_codes_n.main.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(value, key) in formSelectItem.prod_codes_n.main" :key="`selectedMainContract2-${key}`">{{
                          value.text
                        }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.notInsure.indexOf('prod_codes_n_atta') !== -1" class="form-group row">
                <label for="not_insure_subDoc" class="col-2 text-right">附約險別</label>
                <div class="col-10">
                  <div class="form-control h-auto"
                    @click="openSelectModal(formSelectItem.prod_codes_n.atta, secondaryPlanOpt, 'prod_codes_n', 'atta')">
                    <div v-if='formSelectItem.prod_codes_n.atta.length == 0' style="padding:8px 0px;">
                      請選擇或輸入商品名稱
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(value, key) in formSelectItem.prod_codes_n.atta" :key="`selectedAttaContract2-${key}`">{{
                          value.text
                        }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="customizeData.notInsure.indexOf('prod_type_n') !== -1" class="form-group row mt-2">
                <label for="not_insure_prod_type" class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" @click="openProdTypeModal(formSelectItem.prod_type_n, '2')">
                    <div v-if='formSelectItem.prod_type_n.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(value, key) in formSelectItem.prod_type_n" :key="`selected-prod-type-n-${key}`">{{
                          value.text
                        }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="customizeData.cathayCustInfo.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">泰好客
                <a style="cursor: pointer;" @click="openCathayCustInfoModal">
                  <img :src="`${BaseUrl}assets/tagicon/question-mark.png`" width="15" />
                </a>
              </h4>
              <div class="form-group row mt-2">
                <label class="col-2 text-right">促約潛力</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="mkt_level_1" value="高" v-model="formSelectItem.mkt_level">
                    <label for="mkt_level_1">高促約潛力</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input type="checkbox" id="mkt_level_2" value="中高" v-model="formSelectItem.mkt_level">
                    <label for="mkt_level_2">中高促約潛力</label>
                  </div>
                </div>
              </div>
              <div class="form-group row mt-2">
                <label class="col-2 text-right">商品類別</label>
                <div class="col-10">
                  <div class="form-control h-auto" @click="openAddMktTypeModal(formSelectItem.mkt_type)">
                    <div v-if='formSelectItem.mkt_type && formSelectItem.mkt_type.length == 0' style="padding:8px 0px;">
                      請選擇商品類別
                    </div>
                    <div v-else>
                      <div class="d-inline-block p-2 ml-2 mb-2" style="border-radius: 4px;background-color: #e0e1e3;"
                        v-for="(item, key) in formSelectItem.mkt_type" :key="`selected-mkt_type-${key}`">
                        {{ item.text }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="customizeData.futurePayment.length > 0 || customizeData.payment.length > 0" class="row">
              <div class="col-12">
                <h3>契約事件</h3>
              </div>
            </div>
            <div v-show="customizeData.futurePayment.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">給付</h4>
              <div v-show="customizeData.futurePayment.indexOf('matag_month') !== -1" class="form-group row">
                <label for="" class="col-2 text-right">滿期金即將給付</label>
                <div class="col-10">
                  <select v-model="formSelectItem.matag_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(matag_month, index) in formSelect.matag_month" :key="index"
                      :value="matag_month.option">{{ matag_month.name }}</option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.futurePayment.indexOf('annuity_month') !== -1" class="form-group row">
                <label for="" class="col-2 text-right">年金即將給付</label>
                <div class="col-10">
                  <select v-model="formSelectItem.annuity_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(annuity_month, index) in formSelect.annuity_month" :key="index"
                      :value="annuity_month.option">{{ annuity_month.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-show="customizeData.payment.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">續保</h4>
              <div v-show="customizeData.payment.indexOf('pla1_month') !== -1" class="form-group row">
                <label for="" class="col-2 text-right">人壽意外險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.pla1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(pla1_month, index) in formSelect.pla1_month" :key="index"
                      :value="pla1_month.option">{{ pla1_month.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-show="customizeData.paymentProperty.length > 0" class="panel panel-default mb-2">
              <h4 class="text-green mt-0">續保-產險<span class="text-red ml-4">※產險資訊僅能單獨查詢，不得與壽險資訊合併篩選</span></h4>
              <div v-show="customizeData.paymentProperty.indexOf('plc1_month') !== -1" class="form-group row">
                <label for="" class="col-2 text-right">產險車險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.plc1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(plc1_month, index) in formSelect.plc1_month" :key="index"
                      :value="plc1_month.option">{{ plc1_month.name }}</option>
                  </select>
                </div>
              </div>
              <div v-show="customizeData.paymentProperty.indexOf('plf1_month') !== -1" class="form-group row">
                <label for="" class="col-2 text-right">產險火險</label>
                <div class="col-10">
                  <select v-model="formSelectItem.plf1_month" class="form-control">
                    <option value="">請選擇</option>
                    <option v-for="(plf1_month, index) in formSelect.plf1_month" :key="index"
                      :value="plf1_month.option">{{ plf1_month.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <!--公司往來-->
            <div v-show="customizeData.cust_src.length > 0" class="row">
              <div class="col-12">
                <h3>公司往來</h3>
              </div>
            </div>
            <div class="panel panel-default mb-2" v-show="customizeData.cust_src.length > 0">
              <h4 class="text-green mt-0">往來狀況與類型
                  <a style="cursor: pointer;" @click="openCustomerTypeModal">
                  <img :src="`${BaseUrl}assets/tagicon/question-mark.png`" width="15">
                </a>
              </h4>
              <div class="form-group row mt-2" v-show="customizeData.cust_src.indexOf('cust_src1') !== -1">
                <label for="cust_src1" class="col-2 text-right">已往來</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src1-1" 
                      value="1" 
                      v-model="formSelectItem.cust_src1"
                      @change="handleMutualExclusiive('cust_src1', 'cust_src0', '1')"
                    >
                    <label for="cust_src1-1">要保人</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src1-2" 
                      value="2" 
                      v-model="formSelectItem.cust_src1"
                      @change="handleMutualExclusiive('cust_src1', 'cust_src0', '2')"
                    >
                    <label for="cust_src1-2">被保人</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src1-3" 
                      value="3" 
                      v-model="formSelectItem.cust_src1"
                      @change="handleMutualExclusiive('cust_src1', 'cust_src0', '3')"
                    >
                    <label for="cust_src1-3">意外險</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src1-4" 
                      value="5" 
                      v-model="formSelectItem.cust_src1"
                      @change="handleMutualExclusiive('cust_src1', 'cust_src0', '5')"
                    >
                    <label for="cust_src1-4">團險</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src1-5" 
                      value="6" 
                      v-model="formSelectItem.cust_src1"
                      @change="handleMutualExclusiive('cust_src1', 'cust_src0', '6')"
                    >
                    <label for="cust_src1-5">房貸</label>
                  </div>
                </div>
              </div>

              <div class="form-group row mt-2" v-show="customizeData.cust_src.indexOf('cust_src0') !== -1">
                <label for="cust_src0" class="col-2 text-right">未往來</label>
                <div class="col-10">
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src0-1" 
                      value="1" 
                      v-model="formSelectItem.cust_src0"
                      @change="handleMutualExclusiive('cust_src0', 'cust_src1', '1')"
                    >
                    <label for="cust_src0-1">要保人</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src0-2" 
                      value="2" 
                      v-model="formSelectItem.cust_src0"
                      @change="handleMutualExclusiive('cust_src0', 'cust_src1', '2')"
                    >
                    <label for="cust_src0-2">被保人</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src0-3" 
                      value="3" 
                      v-model="formSelectItem.cust_src0"
                      @change="handleMutualExclusiive('cust_src0', 'cust_src1', '3')"
                    >
                    <label for="cust_src0-3">意外險</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src0-4" 
                      value="5" 
                      v-model="formSelectItem.cust_src0"
                      @change="handleMutualExclusiive('cust_src0', 'cust_src1', '5')"
                    >
                    <label for="cust_src0-4">團險</label>
                  </div>
                  <div class="checkbox checkbox-inline">
                    <input 
                      type="checkbox" 
                      id="cust_src0-5" 
                      value="6" 
                      v-model="formSelectItem.cust_src0"
                      @change="handleMutualExclusiive('cust_src0', 'cust_src1', '6')"
                    >
                    <label for="cust_src0-5">房貸</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-right">
              <div class="checkbox checkbox-inline">
                <input type="checkbox" name="favrite" id="favrite" v-model="form.addFavrite" value="1">
                <label for="favrite">
                  將篩選條件加到我的最愛
                </label>
              </div>
              <div style="display: inline-block;">
                <input type="text" placeholder="請輸入標題" class="form-control" :class="{ 'focus': form.addFavrite }"
                  style="width: 250px;" v-model="form.favriteName" :disabled="!form.addFavrite" maxlength="40"
                  @input="checkFavName" />
              </div>
            </div>
            <div class="action text-right">
              <span class="text-red pr-3">※可同時查詢之篩選條件上限15個。(已設定條件{{ countSelection }}個)</span>
              <button type="reset" class="btn btn-default" @click="resetformData">
                重設
              </button>
              <button type="submit" class="btn btn-primary" :disabled="submitDisable"
                @click.stop.prevent="formSubmit()">
                查詢
              </button>
            </div>
          </form>
        </div>
        <div id="tab-1" class="tab-pane" role="tabpanel">
          <div class="row">
            <div class="col-12">
              <button :disabled="records.length == 0" class="btn btn-default float-right py-1 px-2"
                @click="deleteAllQuery">全部刪除</button>
            </div>
          </div>
          <div class="cards four-card card-text-format" :class="{ 'section-loading': recordsLoading }"
            v-if="records.length > 0">


            <!-- 查詢紀錄 -->
            <div class="card filter-record" v-for="(record, i) in records" :key="`record-card-${i}`">
              <div class="content px-0">
                <div class="meta d-flex align-items-center justify-content-between">
                  <small class="text-gray">{{
                    record.searchtime && record.searchtime.split(':').slice(0, 2).join(':')
                  }}</small>
                  <button class="btn btn-default py-1 px-2 m-0" @click="deleteSingleQuery(record)">刪除</button>
                </div>
                <p v-for="(item, index) in record.option_text.split(';')" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="actions">
                <button class="btn btn-primary btn-block" @click.prevent="recordSubmit(record, false)">
                  查詢條件 ({{ record.field_name && recordLength(record.field_name) }})
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <h2 class='text-center'>尚無查詢紀錄</h2>
          </div>
        </div>
        <div id="tab-2" class="tab-pane" role="tabpanel">
          <div class="cards four-card card-text-format">


            <!-- 我的最愛 -->
            <div class="card filter-record" v-for="(fav, i) in favorites" :key="`record-card-${i}`">
              <div class="content">
                <button class="btn btn-icon btn-sm btn-default mb-0 mt-1 mr-0 float-right" @click="openFavorite(fav)">
                  <i class="icon-edit"></i>
                </button>
                <h4 class="mt-1">{{ fav.favorite_name }}</h4>
                <p v-for="(item, index) in fav.option_text.split(';')" :key="index">
                  {{ item }}
                </p>
              </div>
              <div class="actions">
                <button class="btn btn-primary btn-block" @click.stop.prevent="favoriteSubmit(fav)">
                  查詢條件 ({{ fav.field_name && fav.field_name.split('-').length }})
                </button>
              </div>
            </div>


          </div>
        </div>
        <div id="tab-3" class="tab-pane" role="tabpanel">
          <div class="cards four-card card-text-format">
            <!-- 主管推薦 -->
            <div class="card filter-record" v-for="(condition, i) in devConditions" :key="`condition-card-${i}`">
              <div class="content">
                <div class="meta">
                  <h4 class="mt-1">{{ condition.devfilter_name }}</h4>
                  <!-- <small class="text-gray">{{ condition.upload_date | dateFormat }}</small> -->
                </div>
                <p v-for="(item, index) in condition.option_text.split(';')" :key="`condition-opt-${index}`">
                  {{ item }}
                </p>
              </div>
              <div class="actions">
                <button class="btn btn-primary btn-block" @click.prevent="recordSubmit(condition, true)">
                  查詢條件 ({{ condition.field_name.split('-').length }})
                </button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <job-picking-modal :open="jobPickingOpen" @submit="submitJob" @close="jobPickingOpen = false" />

    <customize-filter :open="customizeModalOpen" :customize-data="customizeData"
      @close="panelClose('customizeModalOpen')" @submit="submitFilter" />

    <favorite-modal :open="favoriteModalOpen" :favorite-data="selectedFavo"
      :form-item-data="{ formSelect, cityOpt, grpOpt, mainPlanOpt, secondaryPlanOpt, allTagOpt, prodType1_Opt, prodType2_Opt }"
      @close="panelClose('favoriteModalOpen')" @delete="deleteConfirm" @submit="submitFavorite" />

    <confirm-delete :open="confirmDeleteOpen" :input-data="!deleteItem ? '' : deleteItem"
      @close="panelClose('confirmDeleteOpen')" @confirm="deleteFavoriteItem" />

    <warning-modal :open="warningModalDeleteAllOpen" :showCancel="true" message="您確定要刪除全部「查詢紀錄」嗎?"
      @close="panelClose('warningModalDeleteAllOpen')" @submit="submitDeleteAll" />

    <warning-modal :open="warningModalDeleteOneOpen" :showCancel="true" message="您確定要刪除這筆「查詢紀錄」嗎?"
      @close="panelClose('warningModalDeleteOneOpen')" @submit="submitDeleteOne" />

    <warning-modal :open="warningModalOpen" :showCancel="false" :message="favoriteMessage"
      @submit="panelClose('warningModalOpen')" />

    <warning-modal :open="warningModalRemindOpen" :showCancel="false" :message="'「續保-產險」僅能單獨篩選，不得與其他欄位項目合併篩選，請再次確認您勾選的項目。'" 
      :confirmText="'我知道了'" @submit="panelClose('warningModalRemindOpen')" />

    <!-- 商品主附選擇 modal -->
    <add-contract-modal type="filteruse" :open="selectModalOpen" :selectedContract="modalSelected"
      :allContract="modalUnselected" :title="selectModalTitle" @close="panelClose('selectModalOpen')"
      @submit="updateContract" />

    <!-- 群組選擇 modal -->
    <add-multi-group-modal type="filteruse" :open="groupModalOpen" :selectedGroup="groupSelected"
      :allGroup="groupUnselected" @close="panelClose('groupModalOpen')" @submit="updateGroup" />

    <!-- 客戶標籤說明視窗 -->
    <tag-info-modal :open="tagInfoModalOpen" :data="custTagOpt" :def="custTagDef"
      @close="panelClose('tagInfoModalOpen')" />

    <!-- 客戶標籤選擇 modal -->
    <add-cust-tag-modal type="filteruse" :open="custTagModalOpen" :selectedTag="custTagSelected" :allTag="allTagOpt"
      @close="panelClose('custTagModalOpen')" @submit="updateCustTag" />

    <!-- 商品類別選擇 modal -->
    <add-prod-type-modal type="filteruse" :open="prodTypeModalOpen" :selectedProd="prodTypeSelected"
      :prodType1="prodType1_Opt" :prodType2="prodType2_Opt" @close="panelClose('prodTypeModalOpen')"
      @submit="updateProdType" />

    <!-- 挑選商品類別(泰好客) -->
    <add-mkt-type-modal type="filteruse" :open="addMktTypeModalOpen" :selectedMktType="mktTypeSelected"
      @close="panelClose('addMktTypeModalOpen')" @submit="updateMktType" />

    <!-- 泰好客說明視窗 -->
    <cathay-cust-info-modal :open="cathayCustInfoModalOpen" @close="panelClose('cathayCustInfoModalOpen')" />

    <!-- 公司往來狀況與類型視窗 -->
    <customer-type-modal :open="customerTypeModalOpen" @close="panelClose('customerTypeModalOpen')" />
    
    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { commonMixin } from '../../mixins/common'
import CustomizeFilter from '../components/CustomizeFilter'
import FavoriteModal from '../components/FavoriteModal'
import ConfirmDelete from '../components/ConfirmDelete'
import WarningModal from '../components/WarningModal'
import JobPickingModal from '../components/JobPickingModal';
import AddContractModal from '@/desktop/components/AddContractModal'
import AddMultiGroupModal from '@/desktop/components/AddMultiGroupModal'
import AddCustTagModal from '@/desktop/components/AddCustTagModal'
import TagInfoModal from '@/desktop/components/TagInfoModal'
import AddProdTypeModal from '@/desktop/components/AddProdTypeModal'
import AddMktTypeModal from '@/desktop/components/AddMktTypeModal'
import CathayCustInfoModal from '@/desktop/components/CathayCustInfoModal'
import CustomerTypeModal from '@/desktop/components/CustomerTypeModal'

import { getGroupOfAgnt } from '../../service'
import { queryPlanCode } from '../../service'
import { queryDistByCity } from '../../service'
import { getSearchFilter } from '../../service'
import { getCustomizeFilter } from '../../service'
import { getSearchRecord } from '../../service'
import { getSearchFavorite } from '../../service'
import { insertFavorite } from '../../service'
import { modifyFavorite } from '../../service'
import { modifyCustomizeFilter } from '../../service'
import { deleteFavorite } from '../../service'
import { queryDevCondition } from '../../service'
import { queryDevConditionLog } from '../../service'
import { deleteSearchFilterRecord } from '../../service'
import { log } from 'util';
import mxMask from "@/desktop/components/mxMask";
import { getAllCustTag } from '../../service';
import { getAllProdType } from '../../service';

export default {
  name: 'SearchFilter',
  mixins: [commonMixin],
  components: { CustomizeFilter, FavoriteModal, ConfirmDelete, WarningModal, AddContractModal, AddMultiGroupModal, mxMask, TagInfoModal, AddCustTagModal, AddProdTypeModal, AddMktTypeModal, CathayCustInfoModal, JobPickingModal, CustomerTypeModal },
  computed: {
    ...mapGetters([
      'Cities', 'SliceMode', 'UserInfo', 'BaseUrl'
    ]),
    queryArray() {  //確認是否從 FilterResult 頁面回來
      let ary = []
      for (let index in this.$route.query) {
        ary.push(this.$route.query[index])
      }
      return ary
    },
    isBox() {
      return this.UserInfo.userType === 'box';
    },
    countSelection() {  // 條件篩選已選取的總數量
      //理財工具(勾選「無理財工具時」，數量為1)
      let financeArrLength = this.formSelectItem.finance.length
      if (this.formSelectItem.finance.includes('4'))
        financeArrLength = 1

      let totalSelected = (
        this.numberCount(this.formSelectItem.idage) +
        this.numberCount(this.formSelectItem.birthmonth) +
        this.numberCount(this.formSelectItem.agemonth) +
        this.numberCount(this.formSelectItem.recent_birthday) +

        this.numberCount(this.formSelectItem.sex) +
        this.numberCount(this.formSelectItem.home_addr.city) +
        this.numberCount(this.formSelectItem.groups) +
        this.numberCount(this.formSelectItem.marry) +
        this.numberCount(this.formSelectItem.edu) +
        this.numberCount(this.formSelectItem.std_occupation_cd) +

        this.numberCount(this.formSelectItem.incomy) +
        this.numberCount(this.formSelectItem.family_incom) +
        this.numberCount(this.formSelectItem.invest) +
        financeArrLength +
        this.numberCount(this.formSelectItem.house) +
        this.numberCount(this.formSelectItem.car) +

        this.numberCount(this.formSelectItem.web_member) +
        this.numberCount(this.formSelectItem.online) +
        this.numberCount(this.formSelectItem.mobile) +
        this.numberCount(this.formSelectItem.payment) +
        this.numberCount(this.formSelectItem.email) +
        this.numberCount(this.formSelectItem.trans_plpy) +
        this.numberCount(this.formSelectItem.ecall) +
        this.numberCount(this.formSelectItem.claimoffset) +

        this.numberCount(this.formSelectItem.custrl) +
        this.numberCount(this.formSelectItem.custrl1) +
        this.numberCount(this.formSelectItem.custrl2) +
        this.numberCount(this.formSelectItem.custrl3) +
        this.numberCount(this.formSelectItem.inputYear) +
        this.numberCount(this.formSelectItem.vip_lvl) +
        this.numberCount(this.formSelectItem.cust_tag) +
        this.numberCount(this.formSelectItem.cont_score) +
        this.numberCount(this.formSelectItem.match_cnt) +

        this.formSelectItem.prod_codes_curr.length +
        this.numberCount(this.formSelectItem.prod_codes.main) +
        this.numberCount(this.formSelectItem.prod_codes.atta) +
        this.numberCount(this.formSelectItem.prod_type) +

        this.formSelectItem.prod_codes_n_curr.length +
        this.numberCount(this.formSelectItem.prod_codes_n.main) +
        this.numberCount(this.formSelectItem.prod_codes_n.atta) +
        this.numberCount(this.formSelectItem.prod_type_n) +

        this.formSelectItem.mkt_level.length +
        this.numberCount(this.formSelectItem.mkt_type) +

        this.numberCount(this.formSelectItem.matag_month) +
        this.numberCount(this.formSelectItem.annuity_month) +

        this.numberCount(this.formSelectItem.pla1_month) +
        this.numberCount(this.formSelectItem.plc1_month) +
        this.numberCount(this.formSelectItem.plf1_month) +

        this.formSelectItem.cust_src1.length + 
        this.formSelectItem.cust_src0.length
      )

      return totalSelected
    }
  },
  beforeMount() {
    if (!this.SliceMode)
      this.checkLogin()
  },
  data() {
    return {
      jobPickingOpen: false,
      coltr: 'col-3',
      colsi: 'col-6',
      favoriteMessage: '',
      filterLoading: false,
      currentTab: 0,
      testVal: '',
      groupsVal: '',
      cityOpt: [],
      areaList: [],
      areaOpt: [],
      grpOpt: [],
      mainPlanOpt: [],
      secondaryPlanOpt: [],
      modalSelected: [],
      modalUnselected: [],
      groupSelected: [],
      groupUnselected: [],
      modalType: '',
      modalLevel: '',
      selectModalOpen: false,
      selectModalTitle: '',
      groupModalOpen: false,
      deleteItem: null,
      formValid: true,
      favoriteModalOpen: false,
      customizeModalOpen: false,
      confirmDeleteOpen: false,
      warningModalOpen: false,
      warningModalDeleteAllOpen: false,
      warningModalDeleteOneOpen: false,
      warningModalRemindOpen: false,
      deleteRecord: null,
      recordsLoading: false,
      selectedFavo: null,
      formSelect: {
        idage: [],
        agemonth: [],
        custrl: [],
        custrl1: [],
        custrl2: [],
        custrl3: [],
        custrl4: [],
        vip_lvl: [],
        std_occupation_cd: [],
        family_incom: [],
        finance: [],
        invest: [],
        marry: [],
        edu: [],
        house: [],
        car: [],
        web_member: [],
        online: [],
        mobile: [],
        payment: [],
        email: [],
        sex: [],
        trans_plpy: [],
        ecall: [],
        policy_loan: [],
        claimoffset: [],
        matag_month: [],
        annuity_month: [],
        pla1_month: [],
        plc1_month: [],
        plf1_month: [],
        birthmonth: [],
        incomy: [],
        home_addr_zip: [],
        groups: [],
        prod_codes: [],
        prod_codes_n: [],
        home_addr3: [],
        year_select: [
          { "name": '半年內', "option": '半年內' },
          { "name": '一年內', "option": '一年內' },
          { "name": '二年內', "option": '二年內' },
          { "name": '三年內', "option": '三年內' },
          { "name": '四年內', "option": '四年內' },
          { "name": '五年內', "option": '五年內' }
        ],
        month_select: [
          { "name": '1', "option": '1' },
          { "name": '2', "option": '2' },
          { "name": '3', "option": '3' },
          { "name": '4', "option": '4' },
          { "name": '5', "option": '5' },
          { "name": '6', "option": '6' },
          { "name": '7', "option": '7' },
          { "name": '8', "option": '8' },
          { "name": '9', "option": '9' },
          { "name": '10', "option": '10' },
          { "name": '11', "option": '11' },
          { "name": '12', "option": '12' }
        ],
        cust_tag: [], //客戶標籤
        cont_score: [], //親疏等級        
        cnt_select: [
          { "name": '2~4 次', "option": '1' },
          { "name": '5~7 次', "option": '2' },
          { "name": '8 次以上', "option": '3' }
        ], //符合名單專區次數
        prod_type: [], //已投保_商品類別
        prod_type_n: [], //未投保_商品類別
        recent_birthday: [], //近期生日
        mkt_level: [], //泰好客(促約潛力)
        mkt_type: [], //泰好客(商品類別)
        cust_src1: [], //已往來
        cust_src0: [] //未往來
      },
      formSelectItem: {
        //年紀相關
        idage: '', //年齡
        birthmonth: '', //生日月分
        agemonth: '', //增齡月份
        recent_birthday: '', //近期生日

        //基本資料
        sex: '', //性別
        home_addr: {
          city: '',
          zip: '',
          street: '',
        }, //現居地址
        groups: [], //所屬群組
        marry: '', //婚姻狀況
        edu: '', //教育程度
        std_occupation_cd: '', //職業

        //財務狀況
        incomy: '', //個人年所得
        family_incom: '', //家庭年所得
        invest: '', //月平均投資
        finance: [], //理財工具
        house: '', //住宅權屬
        car: '', //交通工具

        //申辦項目
        web_member: '', //公司網路會員
        online: '', //網路服務線上變更
        mobile: '', //行動服務
        payment: '', //ID一指通
        email: '', //電子單據
        trans_plpy: '', //轉帳申請
        ecall: '', //易CALL保
        claimoffset: '', //理賠抵繳

        //客戶類型
        custrl: '', //客戶關係
        custrl1: '', //保單關係人
        custrl2: '', //幾年未再購
        custrl3: '', //近期有購買
        inputYear: '', //投保始期_民國年
        custrl4: '', //投保始期_月
        vip_lvl: [], //VIP客戶
        cust_tag: [], //客戶標籤
        cont_score: [], //親疏等級
        match_cnt: '', //符合名單專區次數

        //已投保商品
        prod_codes_curr: [], //主約幣別
        prod_codes: {
          main: [],
          atta: []
        }, //主約險別&附約險別
        prod_type: [], //商品類別

        //未投保商品
        prod_codes_n_curr: [],
        prod_codes_n: {
          main: [],
          atta: []
        }, //主約險別&附約險別
        prod_type_n: [], //商品類別

        //泰好客
        mkt_level: [], //泰好客(促約潛力)
        mkt_type: [],  //泰好客(商品類別)

        //給付
        matag_month: '',  //滿期金即將給付
        annuity_month: '', //年金即將給付

        //續保
        pla1_month: '',
        plc1_month: '',
        plf1_month: '',

        job_name: '',
        jobCategory: '',
        policy_loan: '',

        //已往來
        cust_src1: [],
        cust_src1_ch: [],
        
        //未往來
        cust_src0: [],
        cust_src0_ch: []

      },
      submitDisable: true,
      form: {
        addFavrite: false,
        favriteName: '',
        extraAge: ['', ''],
        age: 0,
        birthMonth: '',
        addAge: '',
        // 基本資料
        gender: '',
        groups: '',
        marriage: '',
        education: '',
        career: '',
        liveArea: ['', '', ''],
        customerRelation: [],
        // 財務狀況
        personal_annual_income: '',
        family_annual_income: '',
        monthly_average_investment: '',
        financial_tools: [],
        housing_situation: '',
        transport: [],
        // 申辦項目
        service_company: '',
        service_updateonline: '',
        service_mobile: '',
        service_onefinger: '',
        service_ebill: '',
        service_transfer: '',
        service_eazycall: '',
        service_insureloan: '',
        service_settlement: '',
        // 商品行銷
        mainDoc: '',
        subDoc: '',
        not_insure_mainDoc: '',
        not_insure_subDoc: '',
        cathayCustInfo: '',
        // 契約事件
        payment_1: '',
        payment_2: '',
        insurance_accident: '',
        insurance_car: '',
        insurance_fire: '',
        liveArea: ['', ''],
        customerType: ['', ''],
        payment: [],
        paymentProperty: [],
        //公司往來
        cust_src1: [],
        cust_src0: [],

      },
      records: [],
      favorites: [],
      devConditions: [],
      customizeDataAll: {
        age: ['idage', 'birthmonth', 'agemonth', 'recent_birthday'],
        info: ['sex', 'home_addr', 'groups', 'marry', 'edu', 'std_occupation_cd'],
        financial: ['incomy', 'family_incom', 'invest', 'finance', 'house', 'car'],
        service: ['web_member', 'online', 'mobile', 'payment', 'email', 'trans_plpy', 'ecall', 'policy_loan', 'claimoffset'],
        customerType: ['custrl', 'custrl1', 'custrl2', 'custrl3', 'custrl4', 'vip_lvl', 'cust_tag', 'cont_score', , 'match_cnt'],
        isInsure: ['prod_codes_main', 'prod_codes_atta', 'prod_codes_curr', 'prod_type'],
        notInsure: ['prod_codes_n_main', 'prod_codes_n_atta', 'prod_codes_n_curr', 'prod_type_n'],
        futurePayment: ['matag_month', 'annuity_month'],
        payment: ['pla1_month'],
        paymentProperty: ['plc1_month','plf1_month'], //產險車險 產險火險
        cathayCustInfo: ['mkt_level', 'mkt_type'],
        cust_src: ['cust_src1', 'cust_src0']
      },
      customizeDataDefault: {
        age: ['idage', 'birthmonth', 'agemonth', 'recent_birthday'],
        info: ['home_addr'],
        financial: [],
        service: [],
        customerType: ['custrl', 'custrl1', 'custrl2', 'custrl3', 'custrl4', 'vip_lvl', 'cust_tag', 'cont_score', 'match_cnt'],
        isInsure: [],
        notInsure: ['prod_codes_n_main', 'prod_codes_n_atta', 'prod_type_n'],
        futurePayment: ['matag_month'],
        //payment: ['plc1_month', 'plf1_month'],
        payment: ['pla1_month'],
        paymentProperty: ['plc1_month','plf1_month'],
        cathayCustInfo: ['mkt_level', 'mkt_type'],
        cust_src: ['cust_src1', 'cust_src0']
      },
      customizeData: {
        age: [],
        info: [],
        financial: [],
        service: [],
        customerType: [],
        isInsure: [],
        notInsure: [],
        futurePayment: [],
        payment: [],
        paymentProperty: [],
        cathayCustInfo: [],
        cust_src: []
      },
      mxMaskOpen: false,
      custTagOpt: [], //所有的客戶標籤(說明視窗使用)
      custTagDef: {}, //客戶標籤定義(說明視窗使用)
      allTagOpt: [], //所有的客戶標籤選項
      custTagSelected: [], //已選擇的客戶標籤
      custTagModalOpen: false,
      tagInfoModalOpen: false,
      prodType1_Opt: [], //保障型產品
      prodType2_Opt: [], //理財型產品
      prodTypeSelected: [], //已選擇的商品類別
      prodTypeModalOpen: false,
      prodType: '', //當前選取的商品類別(1:已投保 / 2:未投保)
      mktTypeSelected: [], //已選擇的商品類別(泰好客)
      addMktTypeModalOpen: false,
      cathayCustInfoModalOpen: false, //泰好客說明視窗
      customerTypeModalOpen: false //公司往來狀況與類型視窗
    }
  },
  watch: {
    'form.addFavrite': function () { // 點選篩選條件加到我的最愛 checkbox 清空 input 資料
      this.form.favriteName = ''
    },
    formSelectItem: {  // 判斷使用者是否有選擇條件
      handler(newVal) {
        let hasVal = false
        for (let item in newVal) {
          if (!item || item == "undefined") continue;

          let val = newVal[item]

          if (item == "prod_codes" || item == "prod_codes_n") {
            if (val.main.length > 0 || val.atta.length > 0) {
              hasVal = true;
              break;
            }
          } else {
            if (typeof val == "object") {
              if (Array.isArray(val)) {
                if (val.length > 0) {
                  hasVal = true;
                  break;
                }
              } else if (Object.keys(val).length > 0) {
                for (let j in val) {
                  if (val[j] !== "") {
                    hasVal = true;
                    break;
                  }
                }
              }
            } else if (val !== "") {
              hasVal = true;
              break;
            }
          }
        }
        if (hasVal && this.formSelectItem.idage) {  // 特別判斷自定義年齡
          if (this.form.extraAge[0] === '' && this.form.extraAge[1] === '') {
            this.submitDisable = false
          } else if (this.form.extraAge[0] !== '' && this.form.extraAge[1] !== '') {
            this.submitDisable = false
          } else {
            this.submitDisable = false
          }
        }

        this.checkIsLifeInsOrPropertyIns(newVal,this.countSelection)
      },
      deep: true
    },
    'form.extraAge': function () {
      if (this.form.extraAge[0] == '' && this.form.extraAge[1] == '') {
        this.formSelectItem.idage = ''
        $("#age-3").prop("checked", false);
        $("#age-3").attr("isChecked", "N");
      } else {
        formSelect
        this.formSelectItem.idage = `min:${this.form.extraAge[0]}/max:${this.form.extraAge[1]}`
        $("#age-3").prop("checked", true);
        $("#age-3").attr("isChecked", "Y");

        $("input[name=radio-idage][id!=age-3]").each(function () {
          $(this).prop("checked", false);
          $(this).attr("isChecked", "N");
        });
      }
    },
    'formSelectItem.mkt_level': function (val) {
      if (!val.length && this.formSelectItem.mkt_type.length) {
        this.formSelectItem.mkt_type = []; //取消勾選所有促約潛力，則把商品類別清空
      }
    },
    'formSelectItem.mkt_type': function (val) {
      if (val && val.length) {
        if (this.formSelectItem.mkt_level && !this.formSelectItem.mkt_level.length) {
          this.formSelectItem.mkt_level.push("高");
          this.formSelectItem.mkt_level.push("中高");
        }
      } else {
        this.formSelectItem.mkt_level = []; //取消勾選商品類別，則把促約潛力清空
      }
    }
  },
  methods: {
    checkIsLifeInsOrPropertyIns(formSelectedItemObj,countSelection){
      const carIns = formSelectedItemObj.plc1_month
      const fireIns = formSelectedItemObj.plf1_month
      if( countSelection === 0 && carIns==='' && fireIns===''){
        this.submitDisable = true
      }else if( countSelection == 2   && carIns !== '' && fireIns !== '' ){
        this.submitDisable = false
      }else if( countSelection > 1  && (carIns !== '' || fireIns !== '') ){
        if( this.submitDisable === false ){
          this.showRemindModal();
        } 
        this.submitDisable = true
      }else{
        this.submitDisable = false
      }
        
    },
    //選擇職業
    submitJob(job) {
      this.formSelectItem.job_name = job.job_name;
      this.formSelectItem.jobCategory = job.job_cat;
      this.formSelectItem.std_occupation_cd = job.job_code;
      this.jobPickingOpen = false;
    },
    //檢查輸入年紀
    checkExtraAge(index) {
      this.form.extraAge[index] = this.form.extraAge[index].replace(/[^\d]/g, '');
    },
    //檢查輸入地址
    checkInputAddress() {
      this.formSelectItem.home_addr.street = this.formSelectItem.home_addr.street.replace(/[<>!@#$^&,."'?%*:;+_/{}[\]|~`=\\\s]/g, '');
      if (this.stringBytes(this.formSelectItem.home_addr.street, false, 100) > 100) {
        this.formSelectItem.home_addr.street = this.formSelectItem.home_addr.street.substring(0, this.stringBytes(this.formSelectItem.home_addr.street, true, 100));
      }
    },
    //檢查投保始期-年份
    checkYear() {
      this.formSelectItem.inputYear = this.formSelectItem.inputYear.replace(/[^\d]/g, '');
    },
    //檢查輸入我的最愛名稱
    checkFavName() {
      this.form.favriteName = this.cleanSpecialChar(this.form.favriteName, '@()_&');
      if (this.stringBytes(this.form.favriteName, false, 40) > 40) {
        this.form.favriteName = this.form.favriteName.substring(0, this.stringBytes(this.form.favriteName, true, 40));
      }
    },
    //選取時回傳的數量
    numberCount(item) {
      let type = typeof (item)
      if (type !== undefined) {
        if (item.length === 0)
          return 0
        else
          return 1
      }
      return 0
    },
    ...mapActions([
      'setPageLock'
    ]),
    //  設定點擊頁籤切換 href query
    setRouteQuery(tab) {
      window.location.href = window.location.href.replace(/filter\?.*$/, 'filter') + `?tab=${tab}`
    },
    updateContract(selectedList) {  //  更新已選擇投保商品
      this.formSelectItem[this.modalType][this.modalLevel] = selectedList
      this.panelClose('selectModalOpen')
    },
    openSelectModal(selected, unselected, type, level) {  //  打開投保商品選擇 modal
      this.modalSelected = selected;
      this.modalUnselected = unselected;
      this.modalType = type
      this.modalLevel = level
      if (type == 'prod_codes') {
        if (level == 'main') {
          this.selectModalTitle = '已投保主約'
        } else if (level == 'atta') {
          this.selectModalTitle = '已投保附約'
        }
      } else if (type == 'prod_codes_n') {
        if (level == 'main') {
          this.selectModalTitle = '未投保主約'
        } else if (level == 'atta') {
          this.selectModalTitle = '未投保附約'
        }
      }
      this.panelOpen('selectModalOpen')
    },
    updateGroup(selectedList) {  //  更新已選擇群組
      this.formSelectItem['groups'] = selectedList;
      this.panelClose('groupModalOpen');
    },
    openGroupModal(selected, unselected) {  //  打開群組選擇 modal
      this.groupSelected = selected;
      this.groupUnselected = unselected;
      this.panelOpen('groupModalOpen');
    },
    checkQueryAndSetOpt() {  // 條件篩選搜尋紀錄頁面點選修改條件
      let filterData = []
      for (let i in this.$route.query) {
        if (!i.includes('tab')) {
          filterData.push(this.$route.query[i])
        }
      }

      let field_name = []
      let option = []
      let option_ch = []


      filterData.forEach(item => {
        field_name.push(item.field_name)
        option.push(item.option)
        option_ch.push(item.title)
      })

      field_name.forEach((key, index) => {
        if (key === 'finance') {  //過濾投資工具
          if (option[index].replace(/0/g, '') === '') {
            this.formSelectItem.finance = ['4']
          } else {
            this.formSelectItem.finance = option[index].replace(/0/g, '').split('').map(item => { return Number(item) })
          }
        } else if (key === 'groups') {   //過濾群組
          let grpNameArr = option_ch[index].replace('所屬群組:', '').split(':');
          let grpValArr = option[index].split(':');
          for (var i = 0; i < grpNameArr.length; i++) {
            let grpArr = {
              text: grpNameArr[i],
              val: grpValArr[i]
            };
            this.formSelectItem.groups.push(grpArr);
          }
        } else if (key === 'home_addr1') {   //過濾縣市
          this.formSelectItem.home_addr.city = option[index]

        } else if (key === 'home_addr2') {  //過濾地區
          this.formSelectItem.home_addr.zip = option[index]
        } else if (key === 'home_addr3') {   //過濾地址
          this.formSelectItem.home_addr.street = option[index]
        } else if (key === 'prod_codes') {   //過濾已投保
          let MA = `${option_ch[index].indexOf('主約') > -1 ? 'M' : ''}${option_ch[index].indexOf('附約') > -1 ? 'A' : ''}`
          if (MA == 'M') {
            //已投保商品只有主約
            this.formSelectItem.prod_codes.main = option_ch[index].replace('已投商品:主約:', '').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == item })
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'A') {
            //已投保商品只有附約
            this.formSelectItem.prod_codes.atta = option_ch[index].replace('已投商品:附約:', '').split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == item })
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'MA') {
            //已投保商品有主約&附約
            let dataAry = option_ch[index].split('附約:')
            this.formSelectItem.prod_codes.main = dataAry[0].replace('已投商品:主約:', '').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == item })
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
            this.formSelectItem.prod_codes.atta = dataAry[1].split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == item })
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          }
        } else if (key === 'prod_codes_n') {   //過濾未投保
          let MA = `${option_ch[index].indexOf('主約') > -1 ? 'M' : ''}${option_ch[index].indexOf('附約') > -1 ? 'A' : ''}`
          if (MA == 'M') {
            //未投保商品只有附約
            this.formSelectItem.prod_codes_n.main = option_ch[index].replace('未投商品:主約:', '').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == item })
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'A') {
            //未投保商品只有附約
            this.formSelectItem.prod_codes_n.atta = option_ch[index].replace('未投商品:附約:', '').split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == item })
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          } else if (MA == 'MA') {
            //未投保商品有主約&附約
            let dataAry = option_ch[index].split('附約:')
            this.formSelectItem.prod_codes_n.main = dataAry[0].replace('未投商品:主約:', '').split(':').map(item => {
              let mainAry = this.$store.state.prodMainCode.filter(main => { return main.val == item })
              let chkMainAry = mainAry && mainAry.length > 0 ? true : false
              return {
                text: chkMainAry ? mainAry[0].text : item,
                val: chkMainAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
            this.formSelectItem.prod_codes_n.atta = dataAry[1].split(':').map(item => {
              let subAry = this.$store.state.prodSubCode.filter(main => { return main.val == item })
              let chkSubAry = subAry && subAry.length > 0 ? true : false
              return {
                text: chkSubAry ? subAry[0].text : item,
                val: chkSubAry ? item : item.trim().match(/[^()]+(?=\))/g)[0]
              }
            })
          }
        } else if (key === 'prod_codes_curr') { //有投保幣別
          this.formSelectItem.prod_codes_curr = option[index].split(':').map(item => { return item })

        } else if (key === 'prod_codes_n_curr') {
          this.formSelectItem.prod_codes_n_curr = option[index].split(':').map(item => { return item })
        } else if (key === 'idage') {   //年紀
          let setByUser = ''
          window.aaa = this.formSelect.idage

          this.formSelect.idage.forEach(item => {
            if (item.option === option[index]) {
              setByUser = setByUser + '1'
            }
          })

          if (setByUser === '') {
            let getNewNum = option[index].replace(/.{3}\:/g, '').split('/')
            this.form.extraAge[0] = getNewNum[0]
            this.form.extraAge[1] = getNewNum[1]
            this.formSelectItem.idage = option[index]
          } else {
            this.formSelectItem.idage = option[index]
          }
        } else if (key === 'vip_lvl') { //VIP客戶
          this.formSelectItem.vip_lvl = option[index].split(':').map(item => { return item; });
        } else if (key === 'cust_tag') { //客戶標籤
          let tagNameArr = option_ch[index].replace('客戶標籤:', '').split(':');
          let tagValArr = option[index].split(':');
          for (var t = 0; t < tagNameArr.length; t++) {
            let tagArr = {
              text: tagNameArr[t],
              val: tagValArr[t]
            };
            this.formSelectItem.cust_tag.push(tagArr);
          }
        } else if (key === 'prod_type') { //商品類別(已投保)
          let prodTypeNameArr = option_ch[index].replace('商品類別(已投保):', '').split(':');
          let prodTypeValArr = option[index].split(':');
          for (var p1 = 0; p1 < prodTypeNameArr.length; p1++) {
            let prodTypeArr = {
              text: prodTypeNameArr[p1],
              val: prodTypeValArr[p1]
            };
            this.formSelectItem.prod_type.push(prodTypeArr);
          }
        } else if (key === 'prod_type_n') { //商品類別(未投保)
          let prodType_N_NameArr = option_ch[index].replace('商品類別(未投保):', '').split(':');
          let prodType_N_ValArr = option[index].split(':');
          for (var p2 = 0; p2 < prodType_N_NameArr.length; p2++) {
            let prodType_N_Arr = {
              text: prodType_N_NameArr[p2],
              val: prodType_N_ValArr[p2]
            };
            this.formSelectItem.prod_type_n.push(prodType_N_Arr);
          }
        } else if (key === 'mkt_level') { //泰好客促約潛力
          this.formSelectItem.mkt_level = option[index].split(':');
        } else if (key === 'mkt_type') { //泰好客商品類別
          let mktType_NameArr = option_ch[index].replace('泰好客商品類別:', '').split(':');
          let mktType_ValArr = option[index].split(':');
          for (let y = 0; y < mktType_NameArr.length; y++) {
            let mktType_Arr = {
              text: mktType_NameArr[y],
              val: mktType_ValArr[y]
            };
            this.formSelectItem.mkt_type.push(mktType_Arr);
          }
        } else if (key === 'std_occupation_cd') { //職業
          const pattern = /\W(\d+)\W\s(\W+)/;
          const match = option_ch[index].match(pattern);
          this.formSelectItem[key] = option[index]
          this.formSelectItem['jobCategory'] = match[1]
          this.formSelectItem['job_name'] = match[2]
        } else {
          this.formSelectItem[key] = option[index]
        }

      });
      this.changeCity(this.formSelectItem.home_addr.city)
      this.queryArray.forEach(item => {
        if (item.field_name === 'home_addr2') {
          this.formSelectItem.home_addr.zip = item.option
        } else if (item.field_name === 'home_addr3') {
          this.formSelectItem.home_addr.street = item.option
        }
      })
    },
    // 
    handleMutualExclusiive(currentKey, oppositeKey, value){
      if(this.formSelectItem[currentKey].includes(value)){
        this.formSelectItem[oppositeKey] = this.formSelectItem[oppositeKey].filter(item => item !== value)
      }

      this.syncChineseLabels(currentKey)
      this.syncChineseLabels(oppositeKey)
    },
    syncChineseLabels(key){
      const valueChMap = {
        1: '要保人',
        2: '被保人',
        3: '意外險',
        5: '團險',
        6: '房貸'
      }

      const chKeyMap = {
        cust_src1: 'cust_src1_ch',
        cust_src0: 'cust_src0_ch'
      }

      const chKey = chKeyMap[key]

      if(!chKey) return

      this.formSelectItem[chKey] = this.formSelectItem[key].map(item => valueChMap[item]).filter(Boolean)
    },
    initSearchFilter() {
      this.panelOpen("mxMaskOpen");//開啟遮罩
      getSearchFilter(this.$store.state.userInfo.id).then(result => {
        this.panelClose("mxMaskOpen");//關閉遮罩
        if (result.body && result.body.conditions_list) {
          // 過濾沒有 local 設定的 Key
          let filterAry = Object.keys(this.formSelect)
          result.body.conditions_list.forEach(item => {
            // 過濾沒有 local 設定的 Key
            if (filterAry.includes(item.field_name)) {  // 只設定有對應到 formSelect 的 key
              this.formSelect[item.field_name].push(item)
            }
          })

        }
        this.formSelect.birthmonth = this.formSelect.birthmonth.sort(function (a, b) { return a.ser_no - b.ser_no });
        if (this.queryArray[0] && this.queryArray[0].hasOwnProperty('title') && false) {  //如果是從 filter result 頁面回來 (現在強制false關掉此功能)
          this.queryArray.forEach(item => {
            for (let filterName in this.customizeDataAll) {
              if (this.customizeDataAll[filterName].indexOf(item.field_name) !== -1) {
                this.customizeData[filterName].push(item.field_name)
              }
            }
            if (item.field_name === 'prod_codes') {
              if (item.title.indexOf('主約') > -1) {
                this.customizeData.isInsure.push('prod_codes_main')
              }
              if (item.title.indexOf('附約') > -1) {
                this.customizeData.isInsure.push('prod_codes_atta')
              }
            } else if (item.field_name === 'prod_codes_n') {
              if (item.title.indexOf('主約') > -1) {
                this.customizeData.notInsure.push('prod_codes_n_main')
              }
              if (item.title.indexOf('附約') > -1) {
                this.customizeData.notInsure.push('prod_codes_n_atta')
              }
            } else if (item.field_name === 'home_addr1') {
              this.customizeData.info.push('home_addr')
            }
          })


          // this.customizeData = {...this.customizeDataAll}
          this.setGroupOpt()
          this.setCityOpt()
          this.setPlanOpt()
          this.checkQueryAndSetOpt()
          this.setCustTagOpt()
          this.setProdTypeOpt()
          this.setRecentBirthdayOpt()
        } else {  //如果不是從 filter result 頁面回來 
          getCustomizeFilter(this.$store.state.userInfo.id).then(result => {
            //如果有回傳值
            if (result.body && result.body.field_name && result.body.field_name !== '') {
              let customizeAry = result.body.field_name.split('-')
              for (let filterName in this.customizeDataAll) {
                customizeAry.forEach(item => {
                  if (this.customizeDataAll[filterName].indexOf(item) !== -1) {
                    this.customizeData[filterName].push(item)
                  }
                })
              }
            } else {  //如果回傳空物件
              this.customizeData = { ...this.customizeDataDefault }
            }
            this.setGroupOpt()
            this.setCityOpt()
            this.setPlanOpt()
            this.checkQueryAndSetOpt()
            this.setCustTagOpt()
            this.setProdTypeOpt()
            this.setRecentBirthdayOpt()
          })

        }
      })

    },
    setGroupOpt() {
      getGroupOfAgnt(this.$store.state.userInfo.id, this.$store.state.userInfo.id, 0).then(result => {
        if (result.body.groups) {
          this.grpOpt = result.body.groups.map(eachGroup => {
            return {
              val: eachGroup.grp_id,
              text: eachGroup.grp_name
            }
          })
        } else {
          this.grpOpt = []
        }
      })
    },
    setCityOpt() {
      this.cityOpt = this.Cities.map(item => item.city)
    },
    setPlanOpt() {
      //主約
      queryPlanCode(this.$store.state.userInfo.id, '1').then(result => {
        if (result.body.contract) {
          this.mainPlanOpt = result.body.contract.map(item => {
            return {
              val: item.PROD_ID,
              text: `${item.PROD_NM} (${item.PROD_ID})`
            }
          })
        } else {
          this.mainPlanOpt = []
        }
        if (this.$store.state.prodMainCode && this.$store.state.prodMainCode.length == 0) {
          this.$store.state.prodMainCode = this.mainPlanOpt; //紀錄主約商品
        }
      })
      //附約
      queryPlanCode(this.$store.state.userInfo.id, '2').then(result => {
        if (result.body.contract) {
          this.secondaryPlanOpt = result.body.contract.map(item => {
            return {
              val: item.PROD_ID,
              text: `${item.PROD_NM} (${item.PROD_ID})`
            }
          })
        } else {
          this.secondaryPlanOpt = []
        }
        if (this.$store.state.prodSubCode && this.$store.state.prodSubCode.length == 0) {
          this.$store.state.prodSubCode = this.secondaryPlanOpt; //紀錄附約商品
        }
      })
    },
    checkLogin() {
      var key = this.$store.state.userTokenKey
      if (!key.length > 0) {
        this.$router.push({ path: '/login' })
      }
    },
    deleteFavoriteItem() {
      this.panelClose('favoriteModalOpen')
      this.panelClose('confirmDeleteOpen')
      document.querySelector('html').classList.remove('page-lock')
      document.querySelector('body').classList.remove('page-lock')
      deleteFavorite(this.$store.state.userInfo.id, this.deleteItem.favorite_name).then(result => {
        if (result.header.status === '200') {
          this.initSearchFavorite()
          this.$toast.info({ title: `已刪除「${this.deleteItem.favorite_name}」` })
        } else {
          this.$toast.info({ title: `更新失敗 訊息:${result.header.message}` })
        }
      })
    },
    deleteConfirm(form) {
      this.deleteItem = form
      this.panelOpen('confirmDeleteOpen')
    },
    openFavorite(favo) {
      this.selectedFavo = { ...favo }
      this.panelOpen('favoriteModalOpen')
    },
    submitFavorite(faForm, faExtraAge, faAreaOpt, newName, oldName) {
      // set filter here

      const form = faForm
      const formItem = this.formSelect
      const extraAge = faExtraAge   // modal 回傳參數
      const grpOpt = this.grpOpt
      const areaOpt = faAreaOpt      // modal 回傳參數    
      const mainPlanOpt = this.mainPlanOpt
      const secondaryPlanOpt = this.secondaryPlanOpt
      let filterAry = []

      let idageCustomize = ''     //特別對應自定義年齡
      formItem.idage.forEach(ageItem => {
        if (ageItem.option === form.idage) {
          idageCustomize = idageCustomize + '1'
        } else {
          idageCustomize = idageCustomize + '0'
        }
      })
      for (let key in form) {  //如果是字串或是數字
        if (form[key] !== '' && typeof form[key] !== 'object') {
          if (formItem[key]) {
            formItem[key].forEach(item => {
              if (item.option == form[key]) {
                filterAry.push({ title: `${item.field_description}:${item.name}`, field_name: item.field_name, option: item.option })
              }
            })
          }

          //職業
          if (key === 'std_occupation_cd') {
            filterAry.push({ title: `職業:第${form.jobCategory}類 ${form.job_name}`, field_name: 'std_occupation_cd', option: form.std_occupation_cd });
          }

          //投保始期民國年
          if (key === 'inputYear') {
            //檢查輸入年度是否為數字
            if (this.checkCustomizedAge('year', form.inputYear)) {
              return;
            }
          }

          //幾年未再購
          if (key === 'custrl2') {
            filterAry.push({ title: `幾年未再購:${form.custrl2}`, field_name: 'custrl2', option: form.custrl2 });
          }

          //近期有購買
          if (key === 'custrl3') {
            filterAry.push({ title: `近期有購買:${form.custrl3}`, field_name: 'custrl3', option: form.custrl3 });
          }

          //符合名單專區次數
          if (key === 'match_cnt' && formItem['cnt_select']) {
            formItem['cnt_select'].forEach(item => {
              if (item.option == form[key]) {
                filterAry.push({ title: `符合名單專區次數:${item.name}`, field_name: 'match_cnt', option: item.option });
              }
            });
          }

          if (key === 'idage' && (idageCustomize.indexOf('1') === -1)) { //特別對應自定義年齡
            let extraAgeMin = extraAge[0].trim();
            let extraAgeMax = extraAge[1].trim();
            if (extraAgeMin !== '' || extraAgeMax !== '') {
              //檢查輸入年齡是否為數字
              if (this.checkCustomizedAge('age', extraAgeMin) || this.checkCustomizedAge('age', extraAgeMax)) {
                return;
              }
            }
            if (extraAgeMin !== '' && extraAgeMax === '') {
              filterAry.push({ title: `年齡大於等於:` + extraAgeMin + `歲`, field_name: 'idageCustomize', option: `min:` + extraAgeMin });
            } else if (extraAgeMin === '' && extraAgeMax !== '') {
              filterAry.push({ title: `年齡小於等於:` + extraAgeMax + `歲`, field_name: 'idageCustomize', option: `max:` + extraAgeMax });
            } else if (extraAgeMin !== '' && extraAgeMax !== '') {
              filterAry.push({ title: `年齡:` + extraAgeMin + `歲~` + extraAgeMax + `歲`, field_name: 'idage', option: `min:` + extraAgeMin + `/max:` + extraAgeMax });
            }
          }
        }
        else if (typeof form[key] === 'object') {
          // 如果項目是 Array 
          if (key === 'finance' && form[key].length > 0) {
            let pushString = []
            let pushOption = []
            let descriptionTitle = ''
            let desField_name = ''
            let newAry = [0, 0, 0, 0, 0, 0, 0, 0, 0]
            formItem[key].forEach(itemX => {
              form[key].forEach(itemY => {
                if (itemX.option == itemY) {
                  pushString.push(itemX.name)
                  pushOption.push(itemX.option)
                  descriptionTitle = itemX.field_description
                  desField_name = itemX.field_name
                }
              })
            })
            pushString = pushString.join()
            if (!form[key].includes('4')) {
              pushOption = newAry.map((item, index) => {
                if (pushOption.includes((index + 1).toString())) {
                  return index + 1
                } else {
                  return 0
                }
              }).join('')
            } else {
              pushOption = newAry.join('')
              pushString = '無理財工具'
            }


            filterAry.push({ title: `${descriptionTitle}:${pushString}`, field_name: desField_name, option: pushOption })

            // 如果項目是 現居地址 Object 
          } else if (key === 'home_addr' && form[key].city !== '') {
            let setArea = ''
            let setOption = ''
            areaOpt.forEach(item => {
              if (form[key].zip === item.area) {
                setArea = item.area
                setOption = item.zipcode
              }
            })
            filterAry.push({ title: `縣市:${form[key].city}`, field_name: 'home_addr1', option: form[key].city })
            if (form[key].zip) {
              filterAry.push({ title: `鄉鎮市區:${setArea}`, field_name: 'home_addr2', option: setArea })
            }
            if (form[key].street) {
              filterAry.push({ title: `地址:${form[key].street}`, field_name: 'home_addr3', option: form[key].street })
            }


            // 如果項目是 已投保商品 Object
          } else if (key === 'prod_codes' && (form[key].atta.length !== 0 || form[key].main.length !== 0)) {
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if (form[key].main.length !== 0) {
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if (form[key].atta.length !== 0) {
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }

            let filterOption = ''
            if (setMOption && setAOption) {
              filterOption = setMOption + ';' + setAOption
            } else if (setMOption && !setAOption) {
              //只有主約
              filterOption = setMOption + '!'
            } else {
              //只有附約
              filterOption = setAOption
            }
            filterAry.push({ title: `已投商品:${setMain}${setAtta}`, field_name: 'prod_codes', option: filterOption })


            // 如果項目是 未投保商品 Object
          }
          else if (key === 'prod_codes_n' && (form[key].atta.length !== 0 || form[key].main.length !== 0)) {
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if (form[key].main.length !== 0) {
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if (form[key].atta.length !== 0) {
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }
            let filterOption = ''
            if (setMOption && setAOption) {
              filterOption = setMOption + ';' + setAOption
            } else if (setMOption && !setAOption) {
              //只有主約
              filterOption = setMOption + '!'
            } else {
              //只有附約
              filterOption = setAOption
            }
            filterAry.push({ title: `未投商品:${setMain}${setAtta}`, field_name: 'prod_codes_n', option: filterOption })
          }
          //已投保商品幣別
          else if (key === 'prod_codes_curr' && form[key].length !== 0) {
            let setCurr = ''
            let setCOption = ''
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({ title: `已投保商品幣別:${setCurr}`, field_name: 'prod_codes_curr', option: setCOption })
          }
          //未投保商品幣別
          else if (key === 'prod_codes_n_curr' && form[key].length !== 0) {
            let setCurr = ''
            let setCOption = ''
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({ title: `未投保商品幣別:${setCurr}`, field_name: 'prod_codes_n_curr', option: setCOption })
          } else if (key === 'groups' && form[key].length !== 0) {
            //群組
            let groupText = form.groups.map(item => item.text).join(':');
            let groupVal = form.groups.map(item => item.val.trim()).join(':');
            filterAry.push({ title: `所屬群組:${groupText}`, field_name: 'groups', option: groupVal });
          } else if (key === 'vip_lvl' && form[key].length !== 0) {
            //VIP客戶
            let text = '';
            let val = '';
            if (formItem[key]) {
              formItem[key].forEach(item => {
                form[key].forEach(vipVal => {
                  if (vipVal === item.option) {
                    text += item.name + ',';
                    val += vipVal + ':';
                  }
                })
              })
              if (text !== '' && val !== '') {
                text = text.substring(0, text.length - 1);
                val = val.substring(0, val.length - 1);
                filterAry.push({ title: `VIP客戶:${text}`, field_name: 'vip_lvl', option: val });
              }
            }
          } else if (key === 'cust_tag' && form[key].length !== 0) {
            //客戶標籤
            let tagText = form.cust_tag.map(item => item.text).join(':');
            let tagVal = form.cust_tag.map(item => item.val.trim()).join(':');
            filterAry.push({ title: `客戶標籤:${tagText}`, field_name: 'cust_tag', option: tagVal });
          } else if (key === 'prod_type' && form[key].length !== 0) {
            //產品類別(已投保)
            let prodTypeText = form.prod_type.map(item => item.text).join(':');
            let prodTypeVal = form.prod_type.map(item => item.val.trim()).join(':');
            filterAry.push({ title: `產品類別(已投保):${prodTypeText}`, field_name: 'prod_type', option: prodTypeVal });
          } else if (key === 'prod_type_n' && form[key].length !== 0) {
            //產品類別(未投保)
            let prodType_N_Text = form.prod_type_n.map(item => item.text).join(':');
            let prodType_N_Val = form.prod_type_n.map(item => item.val.trim()).join(':');
            filterAry.push({ title: `產品類別(未投保):${prodType_N_Text}`, field_name: 'prod_type_n', option: prodType_N_Val });
          } else if (key === 'mkt_level' && form[key].length !== 0) {
            //泰好客促約潛力
            let mktLevelVal = form.mkt_level.map(item => item.trim()).join(':')
            filterAry.push({ title: `泰好客促約潛力:${mktLevelVal}`, field_name: 'mkt_level', option: mktLevelVal });
          } else if (key === 'mkt_type' && form[key].length !== 0) {
            //泰好客商品類別
            let mktTypeText = form.mkt_type.map(item => item.text).join(':')
            let mktTypeVal = form.mkt_type.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `泰好客商品類別:${mktTypeText}`, field_name: 'mkt_type', option: mktTypeVal })
          } else if (key === 'cust_src1' && form[key].length !== 0) {
            //往來狀況與類型(已往來)
            let setOption = form[key].map(item => item.trim()).join(':')
            const chKey = key + '_ch'
            let setChOption = form[chKey].map(item => item.trim()).join(':')
            filterAry.push({ title: `公司往來是':${setChOption}`, field_name: 'cust_src1', option: setOption })
          } else if (key === 'cust_src0' && form[key].length !== 0) {
            //往來狀況與類型(未往來)
            let setOption = form[key].map(item => item.trim()).join(':')
            const chKey = key + '_ch'
            let setChOption = form[chKey].map(item => item.trim()).join(':')
            filterAry.push({ title: `公司往來否:${setChOption}`, field_name: 'cust_src0', option: setOption })
          }
        }
      }
      //投保始期:3種情況 (1.年 2.月 3.年+月)
      if (form.custrl4) {
        if (form.inputYear !== '') {
          filterAry.push({ title: `投保始期年份:${form.inputYear}年`, field_name: 'inputYear', option: form.inputYear });
          filterAry.push({ title: `投保始期月份:${form.custrl4}月`, field_name: 'custrl4', option: form.custrl4 });
        } else {
          filterAry.push({ title: `投保始期月份:${form.custrl4}月`, field_name: 'custrl4Only', option: form.custrl4 });
        }
      } else if (form.inputYear !== '') {
        filterAry.push({ title: `投保始期年份:${form.inputYear}年`, field_name: 'inputYearOnly', option: form.inputYear });
      }

      let field_name = []
      let option = []
      let option_ch = []
      let favorite_name = newName
      let original_favorite_name = oldName

      if (filterAry.length === 0) {
        return this.setToastMsg('未輸入任何篩選條件!請確認');
      }

      filterAry.forEach(item => {
        field_name.push(item.field_name)
        option.push(item.option)
        option_ch.push(item.title)
      })

      field_name = field_name.join('-')
      option = option.join('-')
      option_ch = option_ch.join(';')

      modifyFavorite(this.$store.state.userInfo.id, { field_name, option, option_ch, favorite_name, original_favorite_name }).then(result => {
        if (result.header.status === '200') {
          this.initSearchFavorite()
          this.$toast.info({ title: `已更新「${this.selectedFavo.favorite_name}」` })
        } else {
          this.$toast.info({ title: `更新失敗 訊息:${result.header.message}` })
        }
        this.panelClose('favoriteModalOpen')

      })

    },
    submitFilter(form) {
      // set filter here
      let filterItem = []
      for (let key in form) {
        filterItem = [...filterItem, ...form[key]]
      }
      if (filterItem.length <= 30) { // 條件選項不能多於30
        filterItem = filterItem.join('-')
        modifyCustomizeFilter(this.$store.state.userInfo.id, filterItem).then(result => {
          if (result.header.status === '200') {
            this.resetformData()
            this.formSelectItem.idage = ''

            // 確認選項是否為全空
            let formLength = 0
            for (let item in form) {
              formLength = formLength + form[item].length
            }
            if (formLength > 0) {
              this.customizeData = form
            } else {
              // 如果是全空就使用預設物件
              this.customizeData = { ...this.customizeDataDefault }
            }
            this.$toast.info({ title: '編輯成功' })
          } else {
            this.$toast.info({ title: `編輯失敗 訊息:${result.header.message}` })
          }
          this.registerHanlink()
          this.panelClose('customizeModalOpen')
        })
      } else {
        this.$toast.info({ title: '條件不得超過 30項' })
        this.panelClose('customizeModalOpen')
      }

    },
    resetformData() {
      this.form.extraAge = ['', '']
      this.formSelectItem = {
        idage: '',
        agemonth: '',
        custrl: '',
        custrl1: '',
        custrl2: '',
        custrl3: '',
        custrl4: '',
        vip_lvl: [],
        std_occupation_cd: '',
        job_name: '',
        jobCategory: '',
        family_incom: '',
        finance: [], //Array
        invest: '',
        marry: '',
        edu: '',
        house: '',
        car: '',
        web_member: '',
        online: '',
        mobile: '',
        payment: '',
        email: '',
        sex: '',
        trans_plpy: '',
        ecall: '',
        policy_loan: '',
        claimoffset: '',
        matag_month: '',
        annuity_month: '',
        pla1_month: '',
        plc1_month: '',
        plf1_month: '',
        birthmonth: '',
        incomy: '',
        home_addr: {
          city: '',
          zip: '',
          street: '',
        },
        groups: [],
        prod_codes: {
          main: [],
          atta: []
        },
        prod_codes_n: {
          main: [],
          atta: []
        },
        prod_codes_curr: [],
        prod_codes_n_curr: [],
        inputYear: '', //投保始期民國年
        cust_tag: [], //客戶標籤        
        cont_score: [], //親疏等級
        match_cnt: '', //符合名單專區次數
        prod_type: [], //商品類別(已投保)
        prod_type_n: [], //商品類別(未投保)
        recent_birthday: '', //近期生日
        mkt_level: [], //泰好客(促約潛力)
        mkt_type: [], //泰好客(商品類別)
        cust_src1: [],
        cust_src0: [],
      }
    },
    formSubmit() {
      if (this.countSelection > 15) {
        this.$toast.info({ title: '已超過可同時查詢之篩選條件上限15個，請減少勾選的條件' })
        return
      }
      
      const form = this.formSelectItem
      const formItem = this.formSelect
      const extraAge = this.form.extraAge
      const grpOpt = this.grpOpt
      const areaOpt = this.areaOpt
      const mainPlanOpt = this.mainPlanOpt
      const secondaryPlanOpt = this.secondaryPlanOpt
      let filterAry = []

      let idageCustomize = ''     //特別對應自定義年齡
      formItem.idage.forEach(ageItem => {
        if (ageItem.option === form.idage) {
          idageCustomize = idageCustomize + '1'
        } else {
          idageCustomize = idageCustomize + '0'
        }
      })
      for (let key in form) {  //如果是字串或是數字
        if (form[key] !== '' && typeof form[key] !== 'object') {

          if (formItem[key]) {
            formItem[key].forEach(item => {
              if (item.option == form[key]) {
                filterAry.push({ title: `${item.field_description}:${item.name}`, field_name: item.field_name, option: item.option })
              }
            })
          }

          //職業
          if (key === 'std_occupation_cd') {
            filterAry.push({ title: `職業:第${form.jobCategory}類 ${form.job_name}`, field_name: 'std_occupation_cd', option: form.std_occupation_cd });
          }

          //投保始期民國年
          if (key === 'inputYear') {
            //檢查輸入年度是否為數字
            if (this.checkCustomizedAge('year', form.inputYear)) {
              return;
            }
          }

          //幾年未再購
          if (key === 'custrl2') {
            filterAry.push({ title: `幾年未再購:${form.custrl2}`, field_name: 'custrl2', option: form.custrl2 });
          }

          //近期有購買
          if (key === 'custrl3') {
            filterAry.push({ title: `近期有購買:${form.custrl3}`, field_name: 'custrl3', option: form.custrl3 });
          }

          //符合名單專區次數
          if (key === 'match_cnt' && formItem['cnt_select']) {
            formItem['cnt_select'].forEach(item => {
              if (item.option == form[key]) {
                filterAry.push({ title: `符合名單專區次數:${item.name}`, field_name: 'match_cnt', option: item.option });
              }
            });
          }

          if (key === 'idage' && (idageCustomize.indexOf('1') === -1)) { //特別對應自定義年齡
            let extraAgeMin = this.form.extraAge[0].trim();
            let extraAgeMax = this.form.extraAge[1].trim();
            if (extraAgeMin !== '' || extraAgeMax !== '') {
              //檢查輸入年齡是否為數字
              if (this.checkCustomizedAge('age', extraAgeMin) || this.checkCustomizedAge('age', extraAgeMax)) {
                return;
              }
            }
            if (extraAgeMin !== '' && extraAgeMax === '') {
              filterAry.push({ title: `年齡大於等於:` + extraAgeMin + `歲`, field_name: 'idageCustomize', option: `min:` + extraAgeMin });
            } else if (extraAgeMin === '' && extraAgeMax !== '') {
              filterAry.push({ title: `年齡小於等於:` + extraAgeMax + `歲`, field_name: 'idageCustomize', option: `max:` + extraAgeMax });
            } else if (extraAgeMin !== '' && extraAgeMax !== '') {
              filterAry.push({ title: `年齡:` + extraAgeMin + `歲~` + extraAgeMax + `歲`, field_name: 'idage', option: `min:` + extraAgeMin + `/max:` + extraAgeMax });
            }
          }
        }
        else if (typeof form[key] === 'object') {

          // 如果項目是 Array 
          if (key === 'finance' && form[key].length > 0) {
            let pushString = []
            let pushOption = []
            let descriptionTitle = ''
            let desField_name = ''
            let newAry = [0, 0, 0, 0, 0, 0, 0, 0, 0]
            formItem[key].forEach(itemX => {
              form[key].forEach(itemY => {
                if (itemX.option == itemY) {
                  pushString.push(itemX.name)
                  pushOption.push(itemX.option)
                  descriptionTitle = itemX.field_description
                  desField_name = itemX.field_name
                }
              })
            })
            pushString = pushString.join()
            if (!form[key].includes('4')) {
              pushOption = newAry.map((item, index) => {
                if (pushOption.includes((index + 1).toString())) {
                  return index + 1
                } else {
                  return 0
                }
              }).join('')
            }
            else {
              pushOption = newAry.join('')
              pushString = '無理財工具'
            }

            filterAry.push({ title: `${descriptionTitle}:${pushString}`, field_name: desField_name, option: pushOption })

            // 如果項目是 現居地址 Object 
          } else if (key === 'home_addr' && form[key].city !== '') {
            let setArea = ''
            let setOption = ''
            areaOpt.forEach(item => {
              if (form[key].zip === item.area) {
                setArea = item.area
                setOption = item.zipcode
              }
            })
            filterAry.push({ title: `縣市:${form[key].city}`, field_name: 'home_addr1', option: form[key].city })
            if (form[key].zip) {
              filterAry.push({ title: `鄉鎮市區:${setArea}`, field_name: 'home_addr2', option: setArea })
            }
            if (form[key].street) {
              filterAry.push({ title: `地址:${form[key].street}`, field_name: 'home_addr3', option: form[key].street })
            }


            // 如果項目是 已投保商品 Object
          } else if (key === 'prod_codes' && (form[key].atta.length !== 0 || form[key].main.length !== 0)) {
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if (form[key].main.length !== 0) {
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if (form[key].atta.length !== 0) {
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }
            let filterOption = ''
            if (setMOption && setAOption) {
              filterOption = setMOption + ';' + setAOption
            } else if (setMOption && !setAOption) {
              //只有主約
              filterOption = setMOption + '!'
            } else {
              //只有附約
              filterOption = setAOption
            }

            filterAry.push({ title: `已投商品:${setMain}${setAtta}`, field_name: 'prod_codes', option: filterOption })


            // 如果項目是 未投保商品 Object
          }
          else if (key === 'prod_codes_n' && (form[key].atta.length !== 0 || form[key].main.length !== 0)) {
            let setMain = ''
            let setAtta = ''
            let setMOption = ''
            let setAOption = ''
            if (form[key].main.length !== 0) {
              setMain = '主約:' + form[key].main.map(item => item.val).join(':')
              setMOption = form[key].main.map(item => item.val.trim()).join(':')
            }
            if (form[key].atta.length !== 0) {
              setAtta = '附約:' + form[key].atta.map(item => item.val).join(':')
              setAOption = form[key].atta.map(item => item.val.trim()).join(':')
            }
            let filterOption = ''
            if (setMOption && setAOption) {
              filterOption = setMOption + ';' + setAOption
            } else if (setMOption && !setAOption) {
              //只有主約
              filterOption = setMOption + '!'
            } else {
              //只有附約
              filterOption = setAOption
            }
            filterAry.push({ title: `未投商品:${setMain}${setAtta}`, field_name: 'prod_codes_n', option: filterOption })
          }
          //已投保商品幣別
          else if (key === 'prod_codes_curr' && form[key].length !== 0) {
            let setCurr = ''
            let setCOption = ''
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({ title: `已投保商品幣別:${setCurr}`, field_name: 'prod_codes_curr', option: setCOption })
          }
          //未投保商品幣別
          else if (key === 'prod_codes_n_curr' && form[key].length !== 0) {
            let setCurr = ''
            let setCOption = ''
            setCurr = '幣別:' + form[key].map(this.curr).join(':')
            setCOption = form[key].map(item => item.trim()).join(':')
            filterAry.push({ title: `未投保商品幣別:${setCurr}`, field_name: 'prod_codes_n_curr', option: setCOption })
          } else if (key === 'groups' && form[key].length !== 0) {
            //群組
            let groupText = form.groups.map(item => item.text).join(':')
            let groupVal = form.groups.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `所屬群組:${groupText}`, field_name: 'groups', option: groupVal })
          } else if (key === 'vip_lvl' && form[key].length !== 0) {
            //VIP客戶
            let text = '';
            let val = '';
            if (formItem[key]) {
              formItem[key].forEach(item => {
                form[key].forEach(vipVal => {
                  if (vipVal === item.option) {
                    text += item.name + ',';
                    val += vipVal + ':';
                  }
                })
              })
              if (text !== '' && val !== '') {
                text = text.substring(0, text.length - 1);
                val = val.substring(0, val.length - 1);
                filterAry.push({ title: `VIP客戶:${text}`, field_name: 'vip_lvl', option: val });
              }
            }
          } else if (key === 'cust_tag' && form[key].length !== 0) {
            //客戶標籤
            let tagText = form.cust_tag.map(item => item.text).join(':')
            let tagVal = form.cust_tag.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `客戶標籤:${tagText}`, field_name: 'cust_tag', option: tagVal })
          } else if (key === 'prod_type' && form[key].length !== 0) {
            //商品類別(已投保)
            let prodTypeText = form.prod_type.map(item => item.text).join(':')
            let prodTypeVal = form.prod_type.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `商品類別(已投保):${prodTypeText}`, field_name: 'prod_type', option: prodTypeVal })
          } else if (key === 'prod_type_n' && form[key].length !== 0) {
            //商品類別(未投保)
            let prodType_N_Text = form.prod_type_n.map(item => item.text).join(':')
            let prodType_N_Val = form.prod_type_n.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `商品類別(未投保):${prodType_N_Text}`, field_name: 'prod_type_n', option: prodType_N_Val })
          } else if (key === 'mkt_level' && form[key].length !== 0) {
            //泰好客促約潛力
            let mktLevelVal = form.mkt_level.map(item => item.trim()).join(':')
            filterAry.push({ title: `泰好客促約潛力:${mktLevelVal}`, field_name: 'mkt_level', option: mktLevelVal });
          } else if (key === 'mkt_type' && form[key].length !== 0) {
            //泰好客商品類別
            let mktTypeText = form.mkt_type.map(item => item.text).join(':')
            let mktTypeVal = form.mkt_type.map(item => item.val.trim()).join(':')
            filterAry.push({ title: `泰好客商品類別:${mktTypeText}`, field_name: 'mkt_type', option: mktTypeVal })
          }  else if (key === 'cust_src1' && form[key].length !== 0) {
            //往來狀況與類型(已往來)
            let setOption = form[key].map(item => item.trim()).join(':')
            const chKey = key + '_ch'
            let setChOption = form[chKey].map(item => item.trim()).join(':')
            filterAry.push({ title: `公司往來是:${setChOption}`, field_name: 'cust_src1', option: setOption })
          } else if (key === 'cust_src0' && form[key].length !== 0) {
            //往來狀況與類型(未往來)
            let setOption = form[key].map(item => item.trim()).join(':')
            const chKey = key + '_ch'
            let setChOption = form[chKey].map(item => item.trim()).join(':')
            filterAry.push({ title: `公司往來否:${setChOption}`, field_name: 'cust_src0', option: setOption })
          }
        }
      }
      //投保始期:3種情況 (1.年 2.月 3.年+月)
      if (form.custrl4) {
        if (form.inputYear !== '') {
          filterAry.push({ title: `投保始期年份:${form.inputYear}年`, field_name: 'inputYear', option: form.inputYear });
          filterAry.push({ title: `投保始期月份:${form.custrl4}月`, field_name: 'custrl4', option: form.custrl4 });
        } else {
          filterAry.push({ title: `投保始期月份:${form.custrl4}月`, field_name: 'custrl4Only', option: form.custrl4 });
        }
      } else if (form.inputYear !== '') {
        filterAry.push({ title: `投保始期年份:${form.inputYear}年`, field_name: 'inputYearOnly', option: form.inputYear });
      }

      if (filterAry.length == 0) {
        return false
      } else {
        //檢查已填選條件的值的總字數不得超過250個字
        let conditionStr = '';
        filterAry.forEach(item => {
          conditionStr += item.option;
        })
        if (conditionStr.length > 250) {
          return this.setToastMsg('已勾選的條件超過限制總數，請先減少條件後再查詢');
        }
      }

      if (this.form.addFavrite) {  // 新增這次篩選組合到我的最愛
        if (this.form.favriteName.trim() === '') {
          return this.setToastMsg('我的最愛標題尚未輸入！')
        }
        let field_name = []
        let option = []
        let option_ch = []
        let favorite_name = this.form.favriteName

        filterAry.forEach(item => {
          field_name.push(item.field_name)
          option.push(item.option)
          option_ch.push(item.title)
        })

        field_name = field_name.join('-')
        option = option.join('-')
        option_ch = option_ch.join(';')

        insertFavorite(this.$store.state.userInfo.id, { field_name, option, option_ch, favorite_name }).then(result => {
          if (result.header && result.header.status === '200') {
            //  宣告 Vuex 參數
            if( this.formSelectItem.plc1_month !== '' || this.formSelectItem.plf1_month !== ''){
              this.$store.dispatch('setRouterPara', { pathName: 'filterPropertyResult', setData: filterAry })
              this.$router.push({ path: '/filter-property-result' })
            } else {
              this.$store.dispatch('setRouterPara', { pathName: 'filterResult', setData: filterAry })
              this.$router.push({ path: '/filter-result' })
            }
          } else {
            this.favoriteMessage = `
              <h4>${result.header.message}</h4>
            `
            this.panelOpen('warningModalOpen')
          }
        })
      } else {

        //判斷壽險查詢 or 產險查詢
        if( this.formSelectItem.plc1_month !== '' || this.formSelectItem.plf1_month !== ''){
          this.$store.dispatch('setRouterPara', { pathName: 'filterPropertyResult', setData: filterAry })
          this.$router.push({ path: '/filter-property-result' })
        }else{
          this.$store.dispatch('setRouterPara', { pathName: 'filterResult', setData: filterAry })
          this.$router.push({ path: '/filter-result' })
        }
      }

    },
    recordSubmit(item, sentLog) {
      let recordAry = []
      let fieldAry = item.field_name.split('-')
      let optionAry = []
      if (sentLog) {
        optionAry = item.foption.split('-')
        // 如果是主管推薦 送出 log
        queryDevConditionLog(this.$store.state.userInfo.id, item.devfilter_serno, this.$store.state.userInfo.divNo, this.$store.state.userInfo.mktDeptNo)
      } else {
        optionAry = item.option.split('-')
      }
      let CHAry = item.option_ch.split(';')
      fieldAry.forEach((field, index) => {
        recordAry.push({})
        recordAry[index].field_name = field
      })
      optionAry.forEach((option, index) => {
        recordAry[index].option = option
      })
      CHAry.forEach((option_ch, index) => {
        recordAry[index].title = option_ch
      })
      // console.log(recordAry);
      if (fieldAry.includes('plc1_month') || fieldAry.includes('plf1_month')) {
        this.$store.dispatch('setRouterPara', { pathName: 'filterPropertyResult', setData: recordAry })
        this.$router.push({ path: '/filter-property-result' })
      } else {
        this.$store.dispatch('setRouterPara', { pathName: 'filterResult', setData: recordAry })
        this.$router.push({ path: '/filter-result' })
      }
    },
    favoriteSubmit(item) {
      let favoriteAry = []
      let fieldAry = item.field_name.split('-')
      let optionAry = item.option.split('-')
      let CHAry = item.option_ch.split(';')
      fieldAry.forEach((field, index) => {
        favoriteAry.push({})
        favoriteAry[index].field_name = field
      })
      optionAry.forEach((option, index) => {
        favoriteAry[index].option = option
      })
      CHAry.forEach((option_ch, index) => {
        favoriteAry[index].title = option_ch
      })

      // console.log(favoriteAry);
      if (fieldAry.includes('plc1_month') || fieldAry.includes('plf1_month')) {
        this.$store.dispatch('setRouterPara', { pathName: 'filterPropertyResult', setData: favoriteAry })
        this.$router.push({ path: '/filter-property-result' })
      } else {
        this.$store.dispatch('setRouterPara', { pathName: 'filterResult', setData: favoriteAry })
        this.$router.push({ path: '/filter-result' })
      }
    },
    changeCity() {
      this.formSelectItem.home_addr.zip = ''
      this.formSelectItem.home_addr.street = ''
      if (this.formSelectItem.home_addr.city == '') {
        this.areaOpt = []
      } else {
        queryDistByCity(this.$store.state.userInfo.id, this.formSelectItem.home_addr.city).then(result => {
          if (result.body.cityAreaList) {
            this.areaOpt = result.body.cityAreaList.map(item => { return { area: item.AREA, city: item.CITY, zipcode: item.ZIPCODE } })
          } else {
            this.areaOpt = []
          }
        })
      }
    },
    curr(item) {
      switch (item) {
        case 'NTD':
          return "台幣"
          break
        case 'USD':
          return "美元"
          break
        case 'AUD':
          return "澳幣"
          break
        case 'NZD':
          return "紐幣"
          break
        case 'CNY':
          return "人民幣"
          break
      }
    },
    initDevCondition() {  // 主管推薦
      queryDevCondition(this.$store.state.userInfo.id, this.$store.state.userInfo.divNo).then(result => {
        if (result.header && result.header.status == '200') {
          let recordList = result.body.devcondition_list || [];
          this.devConditions = this.initShowLimitText(recordList);
        }
      })
    },
    initSearchRecord() { // 查詢紀錄
      this.recordsLoading = true
      getSearchRecord(this.$store.state.userInfo.id).then(result => {
        if (result.body.record_list) {
          let recordList = result.body.record_list;
          this.records = this.initShowLimitText(recordList);
        } else {
          this.records = [];
        }
        this.recordsLoading = false;
      })
    },
    initSearchFavorite() { // 我的最愛
      getSearchFavorite(this.$store.state.userInfo.id).then(result => {
        if (result.body.record_list) {
          let recordList = result.body.record_list;
          this.favorites = this.initShowLimitText(recordList);
        } else {
          this.favorites = [];
        }
      })
    },
    recordLength(nm) {
      let nmLength = nm && nm.split('-').length || 0;
      if (nmLength > 0) {
        let rAry = nm.split('-');
        rAry.forEach(item => {
          if (item.indexOf('order_asc') !== -1) {
            nmLength = nmLength - 1;
          }
          if (item.indexOf('order_by') !== -1) {
            nmLength = nmLength - 1;
          }
        })

      }
      return nmLength;
    },
    initShowLimitText(resultList) {
      let optionText = '';
      resultList.forEach(item => {
        // 剔除[職業]舊欄位[job]
        let field_array = item.field_name.split('-');
        let ch_array = item.option_ch.split(';');
        let job_index = field_array.indexOf("job");
        if (job_index !== -1) {
          ch_array.splice(job_index, 1);
          item.option_ch = ch_array.join(';');
        }

        if (item.option_ch) {
          if (item.option_ch.length > 48) {
            optionText = item.option_ch.slice(0, 48) + '...';//字卡長度大於48時，僅顯示48個字 + ...
          } else {
            optionText = item.option_ch;
          }
        }
        item.option_text = optionText;
      });
      return resultList;
    },
    deleteAllQuery() {
      this.panelOpen('warningModalDeleteAllOpen')
    },
    deleteSingleQuery(record) {
      this.deleteRecord = record;
      this.panelOpen('warningModalDeleteOneOpen')
    },
    showRemindModal(){
      this.panelOpen('warningModalRemindOpen')
    },
    submitDeleteAll() {
      this.panelClose('warningModalDeleteAllOpen')
      this.recordsLoading = true
      deleteSearchFilterRecord(this.$store.state.userInfo.id).then(result => {
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: result.header.message })
          this.initSearchRecord()
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message })
          } else {
            this.$toast.info({ title: '刪除查詢紀錄失敗' });
          }
        }
        this.recordsLoading = false
      })
    },
    submitDeleteOne() {
      this.panelClose('warningModalDeleteOneOpen')
      this.recordsLoading = true
      deleteSearchFilterRecord(this.$store.state.userInfo.id, this.deleteRecord).then(result => {
        if (result.header && result.header.status == '200') {
          this.$toast.info({ title: result.header.message })
          this.initSearchRecord()
        } else {
          if (result.header && result.header.message) {
            this.$toast.info({ title: result.header.message })
          } else {
            this.$toast.info({ title: '刪除查詢紀錄失敗' });
          }
        }
        this.recordsLoading = false
      })
    },
    toggleRadio(id, eleName, value) {
      var isChecked = "Y" == $("#" + id).attr("isChecked");

      $("input[name=radio-" + eleName + "]").each(function () {
        $(this).prop("checked", false);
        $(this).attr("isChecked", "N");
      });

      if (!isChecked) {
        $("#" + id).prop("checked", true);
        $("#" + id).attr("isChecked", "Y");
        this.formSelectItem[eleName] = value;
      } else {
        this.formSelectItem[eleName] = "";
      }

      if (eleName == "idage") {
        if (!isChecked) {
          if (id != "age-3") {
            this.form.extraAge[0] = "";
            this.form.extraAge[1] = "";
          } else if (!this.form.extraAge[0] && !this.form.extraAge[1]) {
            $("#" + id).prop("checked", false);
            $("#" + id).attr("isChecked", "N");
            this.formSelectItem.idage = "";
          }
        } else {
          if (id == "age-3") {
            //this.form.extraAge[0] = "";
            //this.form.extraAge[1] = "";
          }
        }
      }
    },
    checkCustomizedAge(type, val) {
      if (isNaN(val)) {
        if (type === 'age') {
          this.favoriteMessage = '自定義年齡只能填入數字';
        } else {
          this.favoriteMessage = '投保始期年度只能填入數字';
        }
        this.panelOpen('warningModalOpen');
        return true;
      }
    },
    stringBytes(c, isSub, size) { //計算字元長度 (字串, 是否檢查, 檢查的長度) 
      var n = c.length, s;
      var len = 0;
      for (var i = 0; i < n; i++) {
        s = c.charCodeAt(i);
        while (s > 0) {
          len++;
          s = s >> 8;
          if (isSub && len > size) {
            return i;
          }
        }
      }
      return len;
    },
    //初始化所有客戶標籤
    setCustTagOpt() {
      getAllCustTag(this.$store.state.userInfo.id).then(result => {
        if (result.body.result) {
          this.custTagOpt = result.body.result.cust_tag.map(item => {
            let tagName = item.tag_show_name ? item.tag_show_name : item.tag_name;
            this.allTagOpt.push({ text: tagName, val: item.tag_id });
            return {
              tag_name: tagName,
              text: tagName,
              val: item.tag_id,
              tag_agdef: item.tag_agdef
            };
          });
          this.custTagDef = result.body.result.cust_tag_def || {};
        } else {
          this.custTagOpt = [];
          this.allTagOpt = [];
          this.custTagDef = {};
        }
      });
    },
    // 開啟公司往來狀況與類型視窗
    openCustomerTypeModal() {
      this.panelOpen('customerTypeModalOpen');
    },
    //開啟標籤名稱說明視窗
    openTagInfoModal() {
      this.panelOpen('tagInfoModalOpen');
    },
    //更新已選擇客戶標籤
    updateCustTag(selectedList) {
      this.formSelectItem['cust_tag'] = selectedList;
      this.panelClose('custTagModalOpen');
    },
    //打開客戶標籤選擇 modal
    openCustTagModal(selected) {
      this.custTagSelected = selected;
      this.panelOpen('custTagModalOpen');
    },
    //初始化所有商品類別
    setProdTypeOpt() {
      getAllProdType(this.$store.state.userInfo.id).then(result => {
        if (result.body.result) {
          result.body.result.forEach(item => {
            let category = item.prod_category.trim();
            if (category == "保障型") {
              this.prodType1_Opt.push({
                text: item.second_category,
                val: item.mapping_column
              });
            } else if (category == "理財型") {
              this.prodType2_Opt.push({
                text: item.second_category,
                val: item.mapping_column
              });
            }
          });
        } else {
          this.prodType1_Opt = [];
          this.prodType2_Opt = [];
        }
      });
    },
    //更新已選擇商品類別
    updateProdType(selectedList) {
      if (this.prodType == '1') {
        this.formSelectItem['prod_type'] = selectedList;
      } else {
        this.formSelectItem['prod_type_n'] = selectedList;
      }
      this.panelClose('prodTypeModalOpen');
    },
    //打開商品類別選擇 modal
    openProdTypeModal(selected, type) {
      this.prodTypeSelected = selected;
      this.prodType = type;
      this.panelOpen('prodTypeModalOpen');
    },
    //近期生日下拉選單初始化
    setRecentBirthdayOpt() {
      this.formSelect.recent_birthday = [];
      for (let i = 1; i <= 30; i++) {
        this.formSelect.recent_birthday.push({ name: i.toString(), option: i.toString(), field_description: "近期生日", field_name: "recent_birthday" });
      }
    },
    //更新已選擇商品類別(泰好客)
    updateMktType(selectedList) {
      this.formSelectItem['mkt_type'] = selectedList;
      this.panelClose('addMktTypeModalOpen');
    },
    //打開挑選商品類別(泰好客) modal
    openAddMktTypeModal(selected) {
      this.mktTypeSelected = selected;
      this.panelOpen('addMktTypeModalOpen');
    },
    //開啟泰好客說明視窗
    openCathayCustInfoModal() {
      this.panelOpen('cathayCustInfoModalOpen');
    }
  },
  mounted() {
    this.$store.dispatch('updaCustType', ['1', '2', '3', '4', '5', '6']) // initialize custType

    // 條件篩選
    this.initSearchFilter()

    // 查詢紀錄
    this.initSearchRecord()

    // 我的最愛
    this.initSearchFavorite()

    // 主管推薦
    this.initDevCondition()

    // 依照query切換頁籤
    if (this.$route.query['tab']) {
      $(`a[href="#tab-${this.$route.query['tab']}"]`).tab('show') // Select tab by name
    }

    // 監聽 tabs 切換時觸發難字
    const vm = this
    $('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
      vm.registerHanlink()  // for hard word
    })

    // 監聽 使用者按上一頁或下一頁之行為
    window.popstateMethod = function () {
      // console.log('監聽到上一頁使用!!!')
      $(`a[href="#tab-${vm.$route.query['tab']}"]`).tab('show') // Select tab by name
    }
    window.addEventListener('popstate', window.popstateMethod);

  },
  destroyed() {
    // 移除監聽 使用者按上一頁或下一頁之行為
    // console.log('被砍掉了喔')
    window.removeEventListener("popstate", window.popstateMethod);
  }
}
</script>
<style>
.card-text-format {
  word-wrap: break-word;
  word-break: break-all;
}

.underline {
  text-decoration: underline;
}

.boxPadding {
  padding-top: 0px !important;
}
</style>
